{
  "source": "G:\\Pactios\\Web Chats\\data\\pactios_dashboard.sqlite",
  "tables": {
    "hooks": [
      {
        "hook_id": "TEST-HOOK-01",
        "name": "",
        "source_file": "test-hook.mp4",
        "category": "",
        "notes": "",
        "target_uses": 3,
        "created_at": "2026-07-31T07:08:28.463+00:00",
        "updated_at": "2026-07-31T07:08:28.463+00:00"
      }
    ],
    "videos": [
      {
        "id": "B01",
        "audience": "brand",
        "title": "Плащаш само за съдържанието, което приемеш",
        "batch": "BRAND-01",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Конверсия",
        "claim_risk": "Нисък",
        "goal": "Да обясни основната икономическа разлика на Pactios и да създаде ранни brand заявки.",
        "pain": "Брандът често плаща предварително за производство или абонамент, преди да знае дали съдържанието ще бъде използваемо.",
        "belief_shift": "Не е нужно да купуваш всяко изпратено видео; можеш да приемеш само това, което отговаря на brief-а и нуждите ти.",
        "mechanism": "Брандът публикува brief и reward, creators изпращат съдържание, а acceptance fee и creator compensation се задействат при приемане.",
        "proof": "Продуктова механика, не performance доказателство. Не казвай, че брандът винаги ще получи определен брой submissions.",
        "cta": "Пиши „БРАНД“ за ранен достъп.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "И тук моделът се обръща.",
        "script": "Вместо да платиш за цяла продукция и после да се надяваш, в Pactios публикуваш brief, задаваш възнаграждението и разглеждаш изпратеното съдържание. Приемаш само видеата, които действително искаш. Платформата печели при приет актив, а не само защото си се регистрирал.",
        "duration": 31,
        "visuals": "След hook-а остани в същия кадър. Покажи с ръка „всички файлове“, после физически отдели един „приет“ файл.",
        "overlay_text": "Плащаш при приемане",
        "audio": "Кратък cash-register SFX при думата „приемаш“",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Не купуваш надежда. Приемаш съдържанието, което искаш. Пиши „БРАНД“ за ранен достъп.",
        "cover": "Плащаш само при приемане",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "B02",
        "audience": "brand",
        "title": "Без задължителен месечен абонамент",
        "batch": "BRAND-01",
        "status": "Идея",
        "pillar": "Конверсия",
        "funnel": "Конверсия",
        "claim_risk": "Нисък",
        "goal": "Да премахне възражението срещу още един recurring software разход.",
        "pain": "Малките брандове не искат да плащат всеки месец за платформа, която използват кампанийно.",
        "belief_shift": "UGC платформата може да бъде usage-based, а не поредният абонамент.",
        "mechanism": "Pactios използва acceptance packages и такса на приет актив, без задължителна monthly subscription.",
        "proof": "Това е текущо founder решение. Не твърди, че никога няма да има отделни enterprise договори.",
        "cta": "Пиши „БРАНД“ за ранния списък.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "И не, не ти трябва още един абонамент.",
        "script": "Pactios не започва с месечна такса, която върви независимо дали имаш кампания. Купуваш конкретен брой приемания и използваш единица само когато одобриш актив. Това е модел за реално използване, не за още една икона в списъка с месечни разходи.",
        "duration": 29,
        "visuals": "Покажи ред от измислени subscription икони, зачеркни го и остави една ясна бройка „1 прието видео“.",
        "overlay_text": "Без задължителен абонамент",
        "audio": "Notification SFX, прекъснат при зачеркването",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "UGC според използването, не според календара. Пиши „БРАНД“.",
        "cover": "Не още един абонамент",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "B03",
        "audience": "brand",
        "title": "Brief-ът е поръчката, не първият DM",
        "batch": "BRAND-01",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да покаже защо структурираната задача създава по-добри submissions от неформално запитване.",
        "pain": "Разговорът в DM започва без ясни deliverables, claims, права, срок и критерий за приемане.",
        "belief_shift": "Качеството на UGC започва преди снимането — с brief, който може да бъде изпълнен и проверен.",
        "mechanism": "Pactios превръща нуждата на бранда в структуриран brief с reward и acceptance критерии.",
        "proof": "Образователно твърдение. След реални кампании добави анонимизиран пример преди/след.",
        "cta": "Пиши „БРАНД“, ако искаш да видиш структурата.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Проблемът обикновено започва преди камерата.",
        "script": "„Направи ни нещо готино“ не е brief. Криейтърът трябва да знае продукта, аудиторията, задължителните кадри, забранените твърдения, срока и какво означава прието видео. Pactios събира тези условия на едно място, преди някой да започне да снима.",
        "duration": 30,
        "visuals": "Покажи лист с „нещо готино“, след това го смени със структуриран checklist.",
        "overlay_text": "Лош brief → случайно видео",
        "audio": "Paper rip SFX при смяната",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Добрата UGC кампания започва с brief, който не кара хората да гадаят.",
        "cover": "Това не е brief",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "B04",
        "audience": "brand",
        "title": "DM хаосът не е маркетингова система",
        "batch": "BRAND-01",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да назове ежедневния operational pain на малките маркетинг екипи.",
        "pain": "Разпръснати разговори, файлове, цени и срокове между Instagram, email и chat.",
        "belief_shift": "Проблемът не е, че няма creators; проблемът е, че процесът няма едно място и една логика.",
        "mechanism": "Pactios централизира brief, submissions, acceptance и payment record.",
        "proof": "Не казвай, че платформата премахва всяка комуникация или спор; казвай, че структурира workflow-а.",
        "cta": "Пиши „БРАНД“, ако разпознаваш този хаос.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "И това още е по-подредено от последната ти UGC кампания.",
        "script": "Един creator пише в Instagram, втори изпраща WeTransfer, третият пита за цената във Viber, а някой все още търси последната версия на brief-а. Pactios събира задачата, submissions и решенията за приемане в един workflow. По-малко лов на файлове, повече реален избор.",
        "duration": 31,
        "visuals": "Бързи наслагвания на DM, email и файлове; после чист екран с три стъпки.",
        "overlay_text": "Brief → Submission → Приемане",
        "audio": "Три бързи notification SFX, после тишина",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "UGC не трябва да живее в пет различни приложения.",
        "cover": "DM хаосът",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "B05",
        "audience": "brand",
        "title": "Повече интерпретации на една продуктова идея",
        "batch": "BRAND-01",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Обмисляне",
        "claim_risk": "Среден",
        "goal": "Да продава diversity of creative approaches, без да обещава брой submissions.",
        "pain": "Работата само с един creator дава един стил и ограничен набор от creative angles.",
        "belief_shift": "Brief-ът може да бъде отворен към повече подходящи creators, а брандът да избере най-подходящите изпълнения.",
        "mechanism": "Self-service brief с предварително reward и ограничение на едновременно работещите creators.",
        "proof": "Няма публично обещание за минимален брой submissions до реални liquidity данни.",
        "cta": "Пиши „БРАНД“ за ранен достъп.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Един продукт не трябва да има само едно лице.",
        "script": "Един creator може да е страхотен и пак да не даде всички ъгли, които искаш да тестваш. В Pactios brief-ът може да стигне до различни подходящи creators, а ти избираш изпълненията, които пасват на марката. Разнообразие без обещание, че всяко видео е победител.",
        "duration": 29,
        "visuals": "Смени три различни рамки/позиции около един и същ физически продукт.",
        "overlay_text": "Един brief. Повече гледни точки.",
        "audio": "Три кратки transition SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Един продукт може да звучи по повече от един човешки начин.",
        "cover": "Не залагай на едно лице",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "B06",
        "audience": "brand",
        "title": "Преводът не прави рекламата местна",
        "batch": "BRAND-01",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да позиционира българските creators като локално creative предимство.",
        "pain": "Преведените реклами често звучат формално и неестествено за българска аудитория.",
        "belief_shift": "Локалният език е не само думи, а ритъм, интонация и контекст.",
        "mechanism": "Pactios свързва български брандове с български UGC creators.",
        "proof": "Качествено твърдение. Не добавяй conversion uplift без campaign evidence.",
        "cta": "Пиши „БРАНД“, ако искаш локално звучене.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Преводът на български не прави рекламата българска.",
        "script": "Хората чуват кога текстът е преведен дума по дума. Местният creator знае естествения ритъм, изразите и как реално говори аудиторията. Pactios е направен за български брандове и creators, за да не звучи следващото ти видео като инструкция за пералня.",
        "duration": 30,
        "visuals": "Прочети първата фраза роботизирано от лист, после естествено към камерата.",
        "overlay_text": "Преведено ≠ местно",
        "audio": "Robot filter за първото изречение",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Естественият български не се получава с copy-paste превод.",
        "cover": "Преведено не е местно",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "B07",
        "audience": "brand",
        "title": "Ясна такса на прието видео",
        "batch": "BRAND-01",
        "status": "Идея",
        "pillar": "Конверсия",
        "funnel": "Конверсия",
        "claim_risk": "Среден",
        "goal": "Да направи launch pricing-а конкретен и лесен за повторение.",
        "pain": "UGC офертите често са „по запитване“, което затруднява първия малък тест.",
        "belief_shift": "Platform fee може да бъде предварително видима и обвързана с прието съдържание.",
        "mechanism": "Launch hypothesis: €12 за едно прието видео, €33 за три и €60 за шест, отделно от creator reward и приложимите разходи.",
        "proof": "Работни launch цени от founder decision; показвай пълната разбивка и не представяй creator reward като включен в platform fee.",
        "cta": "Пиши „БРАНД“ за пълната ранна разбивка.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Ето една цена, която не започва с „зависи“.",
        "script": "Таксата на Pactios е дванадесет евро за едно прието видео, тридесет и три за три и шестдесет за шест. Creator reward и приложимите разходи се виждат отделно. Така знаеш какво плащаш на платформата и какво отива към създателя.",
        "duration": 29,
        "visuals": "Покажи три физически ценови етикета: 1 / 3 / 6, после отделен етикет „creator reward“.",
        "overlay_text": "€12 / €33 / €60 platform fee",
        "audio": "Three-count SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Platform fee и creator reward не трябва да бъдат една мъглива сума.",
        "cover": "Ясна такса на приемане",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "B08",
        "audience": "brand",
        "title": "72 часа за решение, не безкрайно чакане",
        "batch": "BRAND-01",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Среден",
        "goal": "Да подготви брандовете за review SLA и да защити creator supply.",
        "pain": "Бавните решения оставят creators без яснота и правят кампаниите непривлекателни.",
        "belief_shift": "Review срокът е част от добрия marketplace, не административна подробност.",
        "mechanism": "Работен Pactios guardrail: review до 72 часа и структурирана причина при отказ.",
        "proof": "Това е launch product rule, което подлежи на legal/operational validation.",
        "cta": "Пиши „БРАНД“, ако искаш структуриран review процес.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Три дни мълчание вече са решение — просто лошо решение.",
        "script": "Когато creator изпрати видео, брандът не трябва да го държи в неизвестност седмици. Pactios планира review до 72 часа: приемане или ясна причина, свързана с brief-а. Бързото решение прави платформата по-предвидима и за двете страни.",
        "duration": 31,
        "visuals": "Покажи таймер 72:00, после две ясни карти „прието“ и „причина“.",
        "overlay_text": "Review до 72 часа",
        "audio": "Timer tick, спрян при решението",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Добрата кампания не държи хората в неизвестност.",
        "cover": "72 часа за решение",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "B09",
        "audience": "brand",
        "title": "Една ясна крайна цена към бранда",
        "batch": "BRAND-01",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Висок",
        "goal": "Да обясни защо platform fee, creator target и reserve трябва да са прозрачни, без да се влиза в персонален данъчен съвет.",
        "pain": "Брандът не иска да изчислява статуса и задълженията на всеки отделен creator.",
        "belief_shift": "Platform checkout може да покаже една крайна сума и отделна прозрачна разбивка.",
        "mechanism": "Commercial calculator използва founder-selected fixed reserve; actual creator settlement остава отделен accountant-approved процес.",
        "proof": "Високорисково правно-счетоводно твърдение. Не публикувай точни tax обещания без професионално одобрение.",
        "cta": "Пиши „БРАНД“ за модела, не за данъчен съвет.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Брандът не трябва да бъде счетоводителят на всеки creator.",
        "script": "Целта на Pactios е брандът да вижда една крайна цена и ясна разбивка: creator reward, platform fee и приложими разходи. Реалното данъчно и осигурително третиране остава отделен професионално одобрен процес. Това видео не е място за универсални данъчни проценти.",
        "duration": 32,
        "visuals": "Покажи една обща фактура и три обозначени компонента; не показвай конкретен statutory процент.",
        "overlay_text": "Една цена. Ясна разбивка.",
        "audio": "Subtle paper stamp",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Прозрачна търговска цена без измислен универсален данъчен отговор.",
        "cover": "Една крайна цена",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "B10",
        "audience": "brand",
        "title": "Няма обещание за viral резултат",
        "batch": "BRAND-01",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да изгради доверие чрез ясна граница на обещанието.",
        "pain": "Маркетингът на UGC често обещава гледания и продажби, които никой не контролира.",
        "belief_shift": "Честният продукт продава процеса и избора, а не гаранция от алгоритъма.",
        "mechanism": "Pactios структурира brief, submission, acceptance, права и плащане; performance остава за измерване.",
        "proof": "Няма нужда от външно доказателство; това е изрична граница на продукта.",
        "cta": "Пиши „БРАНД“, ако предпочиташ процес пред обещание.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Неприятната истина: никой не може да обещае следващото viral видео.",
        "script": "Pactios не обещава продажби, милиони гледания или благоволението на алгоритъма. Платформата обещава по-ясна механика: brief, reward, submissions, приемане и документиран процес. Съдържанието се тества. Резултатът се измерва. Гарантираната вирусност остава при хората с кристалната топка.",
        "duration": 32,
        "visuals": "Счупи или прибери играчка кристална топка, после покажи петте стъпки.",
        "overlay_text": "Процес, не пророчество",
        "audio": "Glass sparkle, cut to dry click",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Алгоритъмът не подписва договори. Процесът може.",
        "cover": "Не обещаваме viral",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "B11",
        "audience": "brand",
        "title": "Един brief, различни интерпретации за тест",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да покаже, че една кампания създава библиотека от различни творчески подходи за тестване.",
        "pain": "Брандът плаща за една продукция, получава един подход и няма какво да сравнява.",
        "belief_shift": "Не ти трябва едно перфектно видео; трябват ти няколко различни, за да видиш кое говори на аудиторията.",
        "mechanism": "Един Pactios brief достига до различни creators, а брандът приема онези интерпретации, които иска да тества.",
        "proof": "Продуктова механика, не performance обещание. Не гарантирай конкретен брой различни submissions.",
        "cta": "Пиши „БРАНД“, ако искаш да тестваш ъгли.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "И точно тук разнообразието става предимство.",
        "script": "Едно студийно видео ти дава една хипотеза. Един Pactios brief може да ти донесе няколко различни прочита на същия продукт — различни лица, ситуации и тон. Приемаш тези, които искаш да тестваш, и оставяш данните да изберат победителя. Така тестването спира да е лукс.",
        "duration": 31,
        "visuals": "Подреди три телефона един до друг с различни кадри на един и същ продукт. Посочи ги последователно.",
        "overlay_text": "Един brief, много прочита",
        "audio": "Три кратки click SFX при посочването",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Данните избират победителя, когато има какво да сравняваш. Пиши „БРАНД“, ако искаш да тестваш ъгли.",
        "cover": "Тествай ъгли, не догадки",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B12",
        "audience": "brand",
        "title": "Как изглежда добрият brief",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да научи брандовете да пишат brief, който води до използваеми submissions.",
        "pain": "Брандът пише две изречения, получава съдържание встрани от очакванията и решава, че UGC не работи.",
        "belief_shift": "Качеството на изпратеното съдържание започва от качеството на заданието, не от късмета.",
        "mechanism": "Pactios brief-ът има структура: продукт, аудитория, желан ъгъл, забранени твърдения, формат и срок.",
        "proof": "Образователна рамка, не гаранция за acceptance. Не обещавай, че добрият brief премахва всички откази.",
        "cta": "Запази това преди първата си кампания.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Разликата почти винаги е в заданието.",
        "script": "Добрият brief казва какво продаваш, на кого и какво чувство търсиш. Казва и какво не бива да се твърди — без медицински обещания, без гаранции. Добавя формат и срок. Пет реда яснота спестяват десет неизползваеми видеа.",
        "duration": 32,
        "visuals": "Покажи лист с пет реда, отмятай ги с маркер един по един. Финален кадър: brief-ът до телефон с готово видео.",
        "overlay_text": "Brief = половината видео",
        "audio": "Тих маркер stroke SFX на всяко отмятане",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Пет реда яснота, десет спестени отказа. Запази това преди първата си кампания.",
        "cover": "Добрият brief в 5 реда",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B13",
        "audience": "brand",
        "title": "Ретейнър всеки месец, видео от време на време",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Осведоменост",
        "claim_risk": "Среден",
        "goal": "Да назове познатия дисбаланс между фиксиран месечен разход и променлив креативен резултат.",
        "pain": "Брандът плаща фиксирана месечна сума, а обемът и качеството на съдържанието варират извън контрола му.",
        "belief_shift": "Разходът за съдържание може да следва приетия резултат, а не календара.",
        "mechanism": "В Pactios брандът задава reward по brief и плаща при приемане на конкретно видео, без месечен ангажимент.",
        "proof": "Сравнявай модели на плащане, не качеството на конкретни агенции. Не твърди, че ретейнърът никога не е оправдан.",
        "cta": "Пиши „БРАНД“, ако плащаш по календар.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Проблемът не е партньорът ти, а моделът.",
        "script": "Ретейнърът е удобен за доставчика: сумата е фиксирана, резултатът — не. Има месеци, в които получаваш много, и месеци, в които плащаш за присъствие. Другият модел е прост: задаваш задача, разглеждаш готови видеа и плащаш за това, което приемеш. Разходът следва резултата.",
        "duration": 32,
        "visuals": "Календар с еднакви суми на всеки месец, до него купчина с различен брой видеа. После разменени: видео срещу сума.",
        "overlay_text": "Плащай резултат, не календар",
        "audio": "Прелистване на календар, после единичен cash SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Разходът за съдържание може да следва резултата. Пиши „БРАНД“, ако плащаш по календар.",
        "cover": "Ретейнър или резултат",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B14",
        "audience": "brand",
        "title": "Започни с една малка кампания",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Конверсия",
        "funnel": "Конверсия",
        "claim_risk": "Среден",
        "goal": "Да свали бариерата за първи опит чрез малък, ограничен експеримент.",
        "pain": "Брандът отлага UGC, защото си представя голям ангажимент с непознат процес.",
        "belief_shift": "Първата кампания може да е малък контролиран тест, не стратегическа трансформация.",
        "mechanism": "Брандът задава един brief с малък reward и ограничен обхват, преглежда submissions и решава дали да продължи.",
        "proof": "Рамкирай като експеримент с ограничен риск. Не обещавай, че малкият тест гарантира успешен резултат.",
        "cta": "Пиши „БРАНД“ за първия малък тест.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Никой не започва с целия бюджет.",
        "script": "Не ти трябва стратегия за шест месеца, за да опиташ. Един продукт, един brief, малък reward. Гледаш какво пристига, приемаш каквото искаш и чак тогава решаваш дали моделът ти върши работа. Малкият тест е най-евтиният начин да разбереш.",
        "duration": 29,
        "visuals": "Начертай на дъска голяма стълба, после я изтрий и остави едно малко стъпало. Стъпи върху него в кадър.",
        "overlay_text": "Едно стъпало стига",
        "audio": "Изтриване на дъска, после единичен step SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Най-евтиният начин да разбереш е малкият тест. Пиши „БРАНД“ за първия малък тест.",
        "cover": "Започни малко",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B15",
        "audience": "brand",
        "title": "Правата са ясни преди първия кадър",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да успокои брандовете, че използването на приетото съдържание е уредено предварително.",
        "pain": "Брандът получава видео, пуска го в реклама и после спори дали е имал право.",
        "belief_shift": "Правата за използване не са преговори след факта, а условие, записано преди заснемането.",
        "mechanism": "Pactios brief-ът описва как брандът може да използва приетото съдържание, и creator-ът вижда това преди да участва.",
        "proof": "Описвай платформената механика, не давай правен съвет. Не твърди, че никога не може да има спор.",
        "cta": "Пиши „БРАНД“, ако искаш ясни условия.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Този спор е излишен, ако редът е обратен.",
        "script": "Най-грозният спор в UGC е след публикуването: „нямаше уговорка за реклама“. В Pactios условията за използване стоят в brief-а, преди creator-ът да снима. Изпратеното е изпратено срещу тези условия. Приемаш видео, чиито права вече са ясни, а не разговор, който тепърва предстои.",
        "duration": 31,
        "visuals": "Покажи договор с маркирани редове, после кадър как файл се влачи в папка „Реклами“ без пауза.",
        "overlay_text": "Правата — преди кадъра",
        "audio": "Кратък paper SFX, после drag-and-drop click",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Условията стоят преди заснемането, не след публикуването. Пиши „БРАНД“, ако искаш ясни условия.",
        "cover": "Ясни права, спокойни реклами",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B16",
        "audience": "brand",
        "title": "Защо лъскавото видео губи в feed-а",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да обясни защо естественото UGC изглежда по-достоверно от студийната продукция в социалните канали.",
        "pain": "Брандът инвестира в перфектна продукция, а аудиторията я разпознава като реклама и скролва.",
        "belief_shift": "В feed-а достоверността носи вниманието, а прекаленият блясък го отблъсква.",
        "mechanism": "Pactios creators снимат raw UGC — телефон, естествена среда, естествена реч — формат, който аудиторията гледа доброволно.",
        "proof": "Обяснявай възприятие и формат, не обещавай по-добри метрики. Не твърди, че студийната продукция е излишна навсякъде.",
        "cta": "Запази това преди следващата продукция.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Причината е проста: хората разпознават реклама от километър.",
        "script": "Перфектната светлина, дикторският глас и лого анимацията казват едно: това е реклама. А рекламите се скролват. Видео, заснето от човек в кухнята му, с естествена реч, се гледа като препоръка. Затова блясъкът има място в кампании, но в feed-а достоверността печели вниманието.",
        "duration": 32,
        "visuals": "Разцепен екран: студийно видео срещу телефонно селфи видео. Пръст скролва лявото, спира на дясното.",
        "overlay_text": "Достоверността печели feed-а",
        "audio": "Swipe SFX отляво, тишина при спирането",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Хората скролват реклами и гледат хора. Запази това преди следващата продукция.",
        "cover": "Защо блясъкът губи",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B17",
        "audience": "brand",
        "title": "Всички submissions на едно място",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да покаже оперативното облекчение от централизиран преглед вместо разпръсната комуникация.",
        "pain": "Видеата пристигат по имейл, WeTransfer и DM, а брандът губи час да събере какво изобщо е получил.",
        "belief_shift": "Прегледът на съдържание е решение на един екран, а не разследване из пет канала.",
        "mechanism": "Всички submissions по един Pactios brief стоят в обща опашка за преглед, където брандът приема или отказва с причина.",
        "proof": "Продуктова механика. Не твърди, че прегледът отнема конкретен брой минути.",
        "cta": "Пиши „БРАНД“, ако събираш видеа от пет места.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Представи си всичко това на един екран.",
        "script": "Едно видео е в пощата, второ в чата, трето е линк, който изтича утре. Докато ги събереш, ентусиазмът е свършил. В Pactios всичко изпратено по brief-а стои на едно място, подредено и готово за решение. Гледаш, приемаш, отказваш с причина. Прегледът става работа за кафе пауза, не за следобед.",
        "duration": 31,
        "visuals": "Покажи хаос от отворени приложения на екран, после един изчистен списък с видеа и две копчета.",
        "overlay_text": "Един екран, всички видеа",
        "audio": "Notification какофония, която спира рязко",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Прегледът е решение, не разследване. Пиши „БРАНД“, ако събираш видеа от пет места.",
        "cover": "Край на разпръснатите видеа",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B18",
        "audience": "brand",
        "title": "Кампанията ти живее в Excel",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да назове познатата ръчна координация, която изяжда времето на малкия маркетинг екип.",
        "pain": "Колони с имена, статуси и линкове, които никой не обновява навреме, докато кампанията се разпада тихо.",
        "belief_shift": "Координацията на creators не е задача за таблица, а за система, която сама пази реда.",
        "mechanism": "Pactios държи brief-а, submissions, статусите и решенията в един процес, без ръчно водена таблица.",
        "proof": "Оперативно наблюдение, не количествено твърдение. Не обещавай конкретен брой спестени часове.",
        "cta": "Пиши „БРАНД“, ако таблицата ти е кампанията.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Ако това ти звучи познато, не си сам.",
        "script": "Колона „писах ли му“, колона „обеща за петък“, колона „линк, който вече не работи“. Таблицата не е системата — тя е симптомът, че системата липсва. Когато brief-ът, изпратеното и решенията стоят в един процес, таблицата просто спира да е нужна. И времето се връща към маркетинга.",
        "duration": 30,
        "visuals": "Екран с истинска хаотична таблица, курсорът се лута. После затваряш прозореца и остава един подреден списък.",
        "overlay_text": "Таблицата е симптом",
        "audio": "Клавиатурно тракане, което спира при затварянето",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Таблицата е симптом, че системата липсва. Пиши „БРАНД“, ако таблицата ти е кампанията.",
        "cover": "Кампания ≠ Excel",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B19",
        "audience": "brand",
        "title": "Отказът с причина пази и твоите кампании",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да обясни защо задължителната причина при отказ е в интерес и на бранда.",
        "pain": "Брандът отказва мълчаливо, creators спират да участват в кампаниите му и качеството на изпратеното пада.",
        "belief_shift": "Едно изречение причина е инвестиция в по-добри submissions следващия път.",
        "mechanism": "В Pactios отказът изисква причина; creators се учат от нея, а брандът с ясна обратна връзка получава по-точни видеа.",
        "proof": "Обяснявай двустранната полза от правилото. Не обещавай конкретен ръст в качеството.",
        "cta": "Пиши „БРАНД“, ако искаш процес с обратна връзка.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Има и втора страна на това правило.",
        "script": "В Pactios не можеш да откажеш видео без причина — и това е нарочно. Причината не е бюрокрация, а сигнал: creators научават какво търсиш и следващите видеа се доближават. Мълчаливият отказ учи хората само да не участват повече. Едно честно изречение днес ти спестява десет грешни видеа утре.",
        "duration": 31,
        "visuals": "Напиши на екран „Не“ и го задраскай. Напиши „Не, защото...“ и остави кадъра да диша.",
        "overlay_text": "Причината е инвестиция",
        "audio": "Драскане на химикал, после тишина",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Едно изречение днес спестява десет грешни видеа утре. Пиши „БРАНД“, ако искаш процес с обратна връзка.",
        "cover": "Защо отказът иска причина",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B20",
        "audience": "brand",
        "title": "Хората скролват покрай реклами, не покрай хора",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да въведе основната идея на UGC пред брандове, които още не са я разглеждали.",
        "pain": "Брандът забелязва, че платените му визии се игнорират, но не знае каква е алтернативата.",
        "belief_shift": "Съдържание, което изглежда като публикация на човек, получава вниманието, което рекламният формат губи.",
        "mechanism": "Pactios свързва бранда с creators, които снимат точно такова човешко, естествено съдържание по зададен brief.",
        "proof": "Принципно обяснение на формата. Не обещавай конкретни CTR или engagement стойности.",
        "cta": "Пиши „БРАНД“, ако рекламите ти се скролват.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Разликата е в първото впечатление.",
        "script": "Мозъкът решава за части от секундата: реклама или човек. Банерът, стоковата музика и перфектният слоган отиват в първата купчина. Видео на човек, който показва продукт в реалния си ден, отива във втората. UGC не е тренд заради модата — а защото се гледа като съдържание, не като прекъсване.",
        "duration": 30,
        "visuals": "Имитирай скролване с палец в близък план: две реклами прелитат, едно човешко видео спира екрана.",
        "overlay_text": "Реклама или човек",
        "audio": "Два бързи swipe SFX, после спокоен ambient",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Вниманието отива при хората, не при банерите. Пиши „БРАНД“, ако рекламите ти се скролват.",
        "cover": "Хора > банери",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B21",
        "audience": "brand",
        "title": "От brief до първите видеа за дни",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Конверсия",
        "claim_risk": "Среден",
        "goal": "Да противопостави скоростта на marketplace модела на класическия продукционен цикъл.",
        "pain": "Брандът чака седмици за оферти, договори, снимачен ден и монтаж, докато поводът за кампанията отминава.",
        "belief_shift": "Съдържанието може да започне да пристига, докато класическата продукция още уточнява офертата.",
        "mechanism": "Публикуваният Pactios brief е видим веднага за creators, които снимат самостоятелно и изпращат без снимачен ден.",
        "proof": "Скоростта зависи от интереса на creators към brief-а. Не обещавай фиксиран срок за първо submission.",
        "cta": "Пиши „БРАНД“, ако поводът не чака.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Разликата е, че никой не чака никого.",
        "script": "Класическата верига е дълга: оферта, одобрение, график, снимачен ден, монтаж, ревизии. В Pactios веригата е кратка: публикуваш brief и creators, които харесат задачата, снимат веднага, всеки сам. Няма общ график, който да се съгласува. Когато поводът е сега, процесът трябва да е сега.",
        "duration": 31,
        "visuals": "Начертай дълга верига от стъпки и я прекъсни. До нея — три стъпки: brief, видео, решение.",
        "overlay_text": "Кратката верига",
        "audio": "Тиктакане, което спира при прекъсването",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Когато поводът е сега, процесът трябва да е сега. Пиши „БРАНД“, ако поводът не чака.",
        "cover": "Дни, не месеци",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B22",
        "audience": "brand",
        "title": "Как да мислиш reward-а",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да даде рамка за определяне на reward спрямо усилието и стойността на заданието.",
        "pain": "Брандът задава произволна сума — твърде ниска и никой не участва, твърде висока без нужда.",
        "belief_shift": "Reward-ът е сигнал за сериозност и сложност на заданието, а не просто разход за минимизиране.",
        "mechanism": "В Pactios brief-ът описва усилието — продукт, сценарий, дубли, срок — и reward-ът трябва да отразява точно него.",
        "proof": "Давай рамка на мислене, не ценоразпис. Не назовавай конкретни суми и не обещавай участие при дадена цена.",
        "cta": "Запази това преди да зададеш reward.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Правилният въпрос не е „колко най-малко“, а „за какво точно“.",
        "script": "Преди да напишеш сума, опиши усилието: трябва ли продуктът да се тества дни наред, има ли сценарий, колко дубъла очакваш. Кратка задача с прост кадър е едно; демонстрация с подготовка е друго. Reward, който уважава усилието, привлича хората, които уважават заданието. Евтиното задание събира скъпи проблеми.",
        "duration": 32,
        "visuals": "Везна: от едната страна списък със задачи, от другата — сумата. Добавяй задачи и показвай как везната се накланя.",
        "overlay_text": "Reward = усилие",
        "audio": "Метален sway SFX на везната",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Reward, който уважава усилието, привлича хора, които уважават заданието. Запази това преди да зададеш reward.",
        "cover": "Колко да е reward-ът",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B23",
        "audience": "brand",
        "title": "Три месеца за едно рекламно видео",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да назове болката от дългия продукционен цикъл, който изостава от пазарния ритъм.",
        "pain": "Докато брифът мине през агенция, график и ревизии, сезонът, поводът или трендът вече са отминали.",
        "belief_shift": "Ритъмът на съдържанието трябва да следва ритъма на пазара, а не на продукционния календар.",
        "mechanism": "Pactios разделя голямата продукция на малки независими задания, които creators изпълняват паралелно.",
        "proof": "Сравнявай процесни модели. Не твърди, че всяка агенционна продукция отнема три месеца.",
        "cta": "Пиши „БРАНД“, ако сезонът те изпреварва.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Проблемът е, че пазарът не чака монтажа.",
        "script": "Кампанията за лятото се одобрява през май, снима се през юни и излиза, когато хората вече мислят за септември. Големите продукции имат своето място, но ежедневното присъствие иска друг ритъм. Малки задания, много creators, паралелна работа. Съдържанието излиза в сезона, за който е направено.",
        "duration": 30,
        "visuals": "Календар, в който лятото се задрасква месец по месец. После четири малки видеа, които пристигат едновременно.",
        "overlay_text": "Пазарът не чака",
        "audio": "Прелистване на страници, после четири бързи pop SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Съдържанието трябва да излиза в сезона, за който е направено. Пиши „БРАНД“, ако сезонът те изпреварва.",
        "cover": "3 месеца за 30 секунди?",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B24",
        "audience": "brand",
        "title": "Купуваш видеото, не профила",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да разграничи raw UGC покупката от инфлуенсър сделките и да премахне объркването.",
        "pain": "Брандът смесва UGC с инфлуенсър маркетинг и очаква reach, който не е част от сделката.",
        "belief_shift": "При raw UGC активът е самото видео за твоите канали, а не публикация в чужд профил.",
        "mechanism": "Pactios raw UGC brief-овете купуват съдържание за каналите на бранда; публикуване от creator-а не е част от заданието.",
        "proof": "Разграничавай двата модела честно. Не твърди, че инфлуенсър моделът е по-лош — той е друга услуга.",
        "cta": "Пиши „БРАНД“, ако търсиш съдържание, не наем на аудитория.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "И това объркване струва пари.",
        "script": "Инфлуенсър сделката наема аудитория: плащаш за публикация в чужд профил. Raw UGC сделката купува съдържание: видео, което пускаш в собствените си канали и реклами. В Pactios brief-ът е за второто. Не гледаш followers, гледаш дали видеото продава продукта ти. Две различни покупки — обърквай ги и бюджетът страда.",
        "duration": 32,
        "visuals": "Два надписа: „наемаш аудитория“ и „купуваш видео“. Зачертай първия за raw UGC контекста и вдигни телефона с видеото.",
        "overlay_text": "Видео ≠ публикация",
        "audio": "Два отчетливи stamp SFX върху надписите",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Raw UGC купува съдържание за твоите канали. Пиши „БРАНД“, ако търсиш съдържание, не наем на аудитория.",
        "cover": "Какво точно купуваш",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B25",
        "audience": "brand",
        "title": "Тествай посланието преди медиа бюджета",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Конверсия",
        "funnel": "Конверсия",
        "claim_risk": "Нисък",
        "goal": "Да позиционира приетите UGC видеа като евтин тест на посланието преди голям рекламен разход.",
        "pain": "Брандът налива медиа бюджет зад едно-единствено криейтив решение и разбира късно, че посланието не работи.",
        "belief_shift": "Малък разход за няколко различни видеа преди кампанията застрахова големия разход след нея.",
        "mechanism": "Брандът приема няколко варианта от един Pactios brief и пуска малки тестове, преди да скалира най-добрия.",
        "proof": "Рамка за процес на тестване. Не обещавай, че тестът винаги намира печеливш вариант.",
        "cta": "Пиши „БРАНД“ преди следващия медиа бюджет.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Редът на разходите решава всичко.",
        "script": "Скъпата грешка не е видеото — а бюджетът, излят зад грешното видео. Обърни реда: първо няколко различни UGC варианта, после малък тест, и чак тогава истинските пари зад победителя. Съдържанието става застраховка на медиа бюджета. Така тестваш послания, а не търпение.",
        "duration": 30,
        "visuals": "Подреди три малки банкноти пред три видеа, после голяма купчина само зад едното.",
        "overlay_text": "Първо тест, после бюджет",
        "audio": "Три малки coin SFX, после един тежък",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Бюджетът отива зад доказаното, не зад надеждата. Пиши „БРАНД“ преди следващия медиа бюджет.",
        "cover": "Застраховай бюджета си",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B26",
        "audience": "brand",
        "title": "Покажи пример, спести десет отказа",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да убеди брандовете да добавят референтен пример към brief-а си.",
        "pain": "Брандът описва желаното с думи, всеки creator си го представя различно и повечето submissions са встрани.",
        "belief_shift": "Един линк към видео, което харесваш, казва повече от абзац описание.",
        "mechanism": "Pactios brief-ът може да включва референции — примерни видеа, които показват търсения тон и структура.",
        "proof": "Практически съвет. Не обещавай, че референцията гарантира съвпадение.",
        "cta": "Запази това преди следващия brief.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Думите описват, примерът показва.",
        "script": "„Искаме нещо свежо и автентично“ значи десет различни неща за десет души. Едно референтно видео — този тон, тази структура, това темпо — подрежда всички представи в една посока. Добави в brief-а линк и едно изречение защо ти харесва. Отказите намаляват, преди да са се случили.",
        "duration": 30,
        "visuals": "Десет стрелки, сочещи в различни посоки, които след показването на телефон с пример се подреждат в една.",
        "overlay_text": "Примерът подрежда",
        "audio": "Кратък whoosh при подреждането на стрелките",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Един пример казва повече от абзац описание. Запази това преди следващия brief.",
        "cover": "Покажи, не описвай",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B27",
        "audience": "brand",
        "title": "Резервът прави бюджета предвидим",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Обмисляне",
        "claim_risk": "Среден",
        "goal": "Да обясни как резервираните средства правят кампанийния разход контролируем от самото начало.",
        "pain": "Брандът се страхува от отворен ангажимент: колко видеа ще дойдат и колко ще дължи накрая.",
        "belief_shift": "Кампанията има финансов таван, който брандът задава сам, преди да е започнала.",
        "mechanism": "В Pactios брандът заделя reserve за кампанията; приетите видеа се покриват от него и разходът не надхвърля заделеното.",
        "proof": "Обяснявай механиката на контрола, без счетоводни или правни съвети. Не обещавай конкретни условия по резерва.",
        "cta": "Пиши „БРАНД“, ако искаш таван на разхода.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Отговорът е прост: таванът си го задаваш ти.",
        "script": "Страхът от marketplace е отвореният край: „ами ако дойдат сто видеа?“ Затова кампанията започва с резерв — сумата, която ти решаваш да заделиш. Приемаш видеа, докато резервът покрива, и спираш, когато решиш. Бюджетът е предвидим не по обещание, а по конструкция.",
        "duration": 31,
        "visuals": "Начертай правоъгълник „бюджет“, запълвай го блокче по блокче с приети видеа и спри на ръба.",
        "overlay_text": "Ти задаваш тавана",
        "audio": "Тихи block-place SFX, после стоп звук на ръба",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Предвидим бюджет по конструкция, не по обещание. Пиши „БРАНД“, ако искаш таван на разхода.",
        "cover": "Бюджет с таван",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B28",
        "audience": "brand",
        "title": "„Ще го снимаме сами… някой ден“",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да адресира брандовете, които планират вътрешно съдържание, но никога не стигат до него.",
        "pain": "Съдържанието стои в списъка със задачи месеци наред, защото винаги има по-спешна работа от снимане.",
        "belief_shift": "Постоянството идва от процес с външен капацитет, а не от добри намерения на заетия екип.",
        "mechanism": "Pactios дава на бранда постоянен достъп до creators, които снимат по brief, без да ангажира вътрешния екип.",
        "proof": "Оперативно наблюдение. Не твърди, че вътрешното съдържание е невъзможно или излишно.",
        "cta": "Пиши „БРАНД“, ако „някой ден“ продължава месеци.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Проблемът не е желанието, а календарът.",
        "script": "Планът беше колегата да снима по едно видео седмично. Мина тримесечие: две видеа, десет извинения. Не защото не иска — защото продажбите, клиентите и огънят за гасене винаги са по-спешни. Съдържание излиза постоянно, когато има кой да го снима извън твоя календар. Екипът ти има други битки.",
        "duration": 31,
        "visuals": "To-do списък, в който „снимаме видео“ се мести надолу от други задачи, докато изпадне от екрана.",
        "overlay_text": "„Някой ден“ не е план",
        "audio": "Повтарящ се тих list-shift SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Постоянството иска капацитет, не намерения. Пиши „БРАНД“, ако „някой ден“ продължава месеци.",
        "cover": "Кога е „някой ден“?",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B29",
        "audience": "brand",
        "title": "Малкият бранд не е малък клиент",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да покаже, че моделът работи и за брандове без маркетингов отдел и голям бюджет.",
        "pain": "Малкият бранд смята, че creator кампаниите са игра само за компании с агенции и шестцифрени бюджети.",
        "belief_shift": "Структурираният brief с малък reward е достатъчен вход — без отдел, без агенция, без обем.",
        "mechanism": "Pactios процесът е един и същ за всички брандове: brief, submissions, приемане — независимо от размера.",
        "proof": "Позициониране на достъпност. Не обещавай еднакъв интерес на creators към всяка кампания.",
        "cta": "Пиши „БРАНД“, дори екипът ти да си ти.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Истината е, че процесът не пита колко сте на брой.",
        "script": "Ако брандът ти е двама души и склад, вероятно си отписал creator маркетинга като лига на големите. Но процесът тук не иска отдел — иска ясен brief и честен reward. Публикуваш задача като всеки друг бранд и разглеждаш същите submissions. Размерът на екипа не е входен билет.",
        "duration": 30,
        "visuals": "Огромно офис лого до малко домашно бюро — и еднакъв brief екран пред двете.",
        "overlay_text": "Същият процес за всички",
        "audio": "Неутрален ambient, без промяна между кадрите",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Ясният brief е входът, не размерът на екипа. Пиши „БРАНД“, дори екипът ти да си ти.",
        "cover": "И за малки брандове",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B30",
        "audience": "brand",
        "title": "Един продукт, три ъгъла",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да даде проста рамка за планиране на няколко brief-а около един продукт.",
        "pain": "Брандът изчерпва „представяме продукта“ с първото видео и не знае какво да поръча след това.",
        "belief_shift": "Един продукт носи много истории: болка, демонстрация, доверие — всяка е отделно задание.",
        "mechanism": "В Pactios всеки ъгъл става отделен brief с ясна цел, вместо едно видео да опитва да каже всичко.",
        "proof": "Креативна рамка. Не обещавай, че всеки ъгъл ще произведе успешно видео.",
        "cta": "Запази рамката за следващата кампания.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Продуктът е един, историите са три.",
        "script": "Ъгъл едно: болката — денят без продукта. Ъгъл две: демонстрацията — продуктът върши работата пред камерата. Ъгъл три: доверието — човекът, който вече го ползва и защо остава. Три отделни brief-а, три различни видеа, една продуктова истина. Спираш да питаш „какво да снимаме“ и започваш да питаш „кой ъгъл е наред“.",
        "duration": 32,
        "visuals": "Постави продукта в центъра и завърти около него три листчета: болка, демо, доверие.",
        "overlay_text": "Болка · Демо · Доверие",
        "audio": "Три меки page-flip SFX при листчетата",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Един продукт, три истории, три brief-а. Запази рамката за следващата кампания.",
        "cover": "Трите ъгъла на продукта",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B31",
        "audience": "brand",
        "title": "Кампания и без физически продукт",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да отвори модела за услуги, приложения и дигитални продукти, не само за кутии по куриер.",
        "pain": "Брандът с услуга или приложение решава, че UGC е само за продукти, които се разопаковат.",
        "belief_shift": "Опитът с услуга — преди и след, екран, резултат — е също толкова снимаема история.",
        "mechanism": "Pactios brief-ът може да дава достъп до услуга или приложение вместо пратка, а creator-ът снима реалното използване.",
        "proof": "Продуктова възможност. Не твърди, че всяка услуга е подходяща за UGC формат.",
        "cta": "Пиши „БРАНД“, дори да нямаш какво да изпратиш по куриер.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Кутията не е задължителна част от историята.",
        "script": "UGC не започва с разопаковане — започва с проблем. Услугата ти решава нещо: покажи деня преди и деня след. Приложението ти спестява време: покажи екрана и резултата. В brief-а даваш достъп вместо пратка и creator-ът снима реалното преживяване. Историята е опитът, не кашонът.",
        "duration": 31,
        "visuals": "Задраскай нарисуван кашон. Покажи телефон с приложение и отметнат резултат в реална среда.",
        "overlay_text": "Опитът е продуктът",
        "audio": "Кратък app notification SFX при резултата",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "UGC започва с проблем, не с разопаковане. Пиши „БРАНД“, дори да нямаш какво да изпратиш по куриер.",
        "cover": "UGC без кашон",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B32",
        "audience": "brand",
        "title": "Първата кампания не те обвързва с втора",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Конверсия",
        "funnel": "Конверсия",
        "claim_risk": "Нисък",
        "goal": "Да премахне страха от обвързване като последна бариера пред първия опит.",
        "pain": "Брандът бави решението, защото очаква скрит абонамент, срочен договор или задължителен обем.",
        "belief_shift": "Опитът е самостоятелен: една кампания, едно решение, нула ангажимент за следваща.",
        "mechanism": "Pactios няма задължителен обем или срочен ангажимент — втората кампания съществува само ако брандът я поиска.",
        "proof": "Продуктов факт за модела. Не обещавай бъдещи условия или цени.",
        "cta": "Пиши „БРАНД“ за една кампания без втора.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Затова правилото тук е едно.",
        "script": "Знаеш модела: пробен период, после фактура, за която не помниш да си се съгласявал. Тук първата кампания е точно една кампания. Приключва, гледаш резултата и решаваш на чисто. Ако не продължиш, нищо не тече. Опитът трябва да е решение, а не капан.",
        "duration": 29,
        "visuals": "Покажи договор с много страници и го остави настрана. Вдигни един лист с една задача.",
        "overlay_text": "Една кампания. Точка.",
        "audio": "Тежко тупване на договора, лек лист SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Опитът е решение, не капан. Пиши „БРАНД“ за една кампания без втора.",
        "cover": "Без обвързване",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B33",
        "audience": "brand",
        "title": "UGC не е само за козметика",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да разшири представата кои категории продукти работят в UGC формат.",
        "pain": "Брандът извън beauty и мода приема, че форматът не е за неговата категория.",
        "belief_shift": "Навсякъде, където има ежедневен проблем и видим резултат, има UGC история.",
        "mechanism": "Pactios brief-ът задава контекста на употреба, а creators показват продукта в реалната му среда — каквато и да е тя.",
        "proof": "Разширяване на представата с примери за категории. Не обещавай еднакъв интерес на creators по всички категории.",
        "cta": "Пиши „БРАНД“, дори нишата ти да е „скучна“.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Форматът не пита за категория, а за история.",
        "script": "Крем пред огледалото — очаквано. Но и инструментът, който събра гардероба за час, е UGC. И софтуерът, който изяде съботната ти бумащина. И храната за куче, заради която мискетата спря да мрънка. Скучните ниши често печелят най-много, защото никой в тях не говори по човешки. Проблем плюс резултат прави история.",
        "duration": 32,
        "visuals": "Бърза поредица: инструмент, екран със софтуер, купичка на куче — всичките снимани по телефонному, без блясък.",
        "overlay_text": "Всяка ниша има история",
        "audio": "Три бързи cut SFX между кадрите",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Проблем + видим резултат = UGC история. Пиши „БРАНД“, дори нишата ти да е „скучна“.",
        "cover": "UGC извън козметиката",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B34",
        "audience": "brand",
        "title": "Една реклама, кратък живот",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Осведоменост",
        "claim_risk": "Среден",
        "goal": "Да назове creative fatigue като причина за постоянна нужда от ново съдържание.",
        "pain": "Брандът върти една и съща реклама, аудиторията я е виждала, а нова продукция няма откъде да дойде бързо.",
        "belief_shift": "Проблемът не е таргетингът, а умореният криейтив — нужен е постоянен приток на свежи видеа.",
        "mechanism": "Pactios кампаниите носят нови интерпретации без нова продукция — brief-ът работи, докато брандът приема свежи видеа.",
        "proof": "Общ рекламен принцип. Не назовавай конкретни числа за умора или честота на смяна.",
        "cta": "Пиши „БРАНД“, ако рекламата ти се е уморила.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "И тогава проблемът вече не е таргетингът.",
        "script": "Първата седмица рекламата работи. После същите хора я виждат за пети път и тя става тапет. Вдигаш бюджета — плащаш повече за същото безразличие. Умореният криейтив не се лекува с настройки, а със свежо видео. Което значи, че притокът на съдържание е част от медиа плана, не украса към него.",
        "duration": 31,
        "visuals": "Едно и също видео, повтаряно в grid, избледнява. Отстрани влиза колона нови различни кадри.",
        "overlay_text": "Свежото видео е горивото",
        "audio": "Затихващ loop, прекъснат от свеж pop SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Умореният криейтив не се лекува с настройки. Пиши „БРАНД“, ако рекламата ти се е уморила.",
        "cover": "Рекламата се умори",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B35",
        "audience": "brand",
        "title": "Правилата важат и за бранда",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да покаже, че платформата държи отговорни и двете страни, което прави процеса надежден.",
        "pain": "Брандът очаква marketplace, в който creators изчезват, а не система, която пази реда и в двете посоки.",
        "belief_shift": "Надеждният процес съществува, защото задълженията са двупосочни — и брандът има срокове и правила.",
        "mechanism": "В Pactios брандът дължи ясен brief, преглед в срок и причина при отказ — същата дисциплина, която иска от creators.",
        "proof": "Описвай двустранните правила като структура на процеса. Не обещавай нулеви проблеми.",
        "cta": "Пиши „БРАНД“, ако цениш ред и в двете посоки.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Но редът има цена и за теб.",
        "script": "Лесно е да искаш дисциплина от другите: срокове, качество, следване на brief-а. Тук дисциплина дължиш и ти — ясно задание, преглед в срок, причина при отказ. Точно затова системата работи: никой не чака в мълчание и никой не гадае. Редът, който получаваш, е редът, който даваш.",
        "duration": 30,
        "visuals": "Две ръце си стискат ръцете над бюро, после два еднакви чеклиста — един за бранд, един за creator.",
        "overlay_text": "Ред и в двете посоки",
        "audio": "Два симетрични check SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Редът, който получаваш, е редът, който даваш. Пиши „БРАНД“, ако цениш ред и в двете посоки.",
        "cover": "Правила и за двете страни",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B36",
        "audience": "brand",
        "title": "Забраните в brief-а пестят откази",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Среден",
        "goal": "Да научи брандовете да изброяват забранените твърдения предварително.",
        "pain": "Creator-ът добронамерено обещава чудеса пред камерата и брандът трябва да отказва иначе добри видеа.",
        "belief_shift": "Списъкът със забранени твърдения пази и бранда от риск, и creator-а от отказ.",
        "mechanism": "Pactios brief-ът има място за забрани — какво не бива да се твърди — видимо преди заснемането.",
        "proof": "Процесен съвет за рискови категории. Не давай правна консултация и не изброявай регулаторни правила като съвет.",
        "cta": "Пиши „БРАНД“, ако продуктът ти има чувствителни клейми.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Защото ентусиазмът обещава повече от продукта.",
        "script": "Creator-ът иска видеото да е убедително и казва „гарантирано действа за три дни“. Ти знаеш, че такова обещание не бива да излиза от бранда ти. Затова забраните стоят в brief-а: без медицински твърдения, без гаранции, без сравнения с конкретни марки. Едно поле със забрани — по-малко неизползваеми видеа и по-спокойни одобрения.",
        "duration": 32,
        "visuals": "Реч балон с „гарантирано!“, който се зачертава. До него — кратък списък „Не казвай“.",
        "overlay_text": "Кажи какво да НЕ казват",
        "audio": "Драскащ maker SFX при зачертаването",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Забраните пазят бранда от риск и creator-а от отказ. Пиши „БРАНД“, ако продуктът ти има чувствителни клейми.",
        "cover": "Полето „забрани“",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B37",
        "audience": "brand",
        "title": "Повтори brief-а, който работи",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да покаже как работещото задание се превръща в повторяем процес за нови видеа.",
        "pain": "Брандът намира работеща формула, но всяка следваща кампания я строи от нулата.",
        "belief_shift": "Работещият brief е актив: повтаряш структурата с нови creators и получаваш свежи варианти на доказаното.",
        "mechanism": "В Pactios брандът пуска отново същия brief, а нови creators дават нови изпълнения на проверената рамка.",
        "proof": "Процесна възможност. Не обещавай, че повторението носи същия резултат всеки път.",
        "cta": "Пиши „БРАНД“, ако вече знаеш какво работи.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Работещото задание не се архивира — то се повтаря.",
        "script": "Най-ценният документ в маркетинга ти е brief-ът, който вече е дал добро видео. Не го оставяй в папката. Пусни го пак: същата структура, същите забрани, нови лица и нови ситуации. Доказаната рамка плюс свежо изпълнение е най-краткият път до следващото работещо видео.",
        "duration": 30,
        "visuals": "Копирай документ на екрана и покажи как от копието излизат три нови различни видеа.",
        "overlay_text": "Работещото се повтаря",
        "audio": "Copy-paste click, после три меки pop SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Доказана рамка + свежо изпълнение = следващото видео. Пиши „БРАНД“, ако вече знаеш какво работи.",
        "cover": "Повтори успеха",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B38",
        "audience": "brand",
        "title": "Обратната връзка е инвестиция",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да научи брандовете да дават конкретна обратна връзка, която подобрява следващите submissions.",
        "pain": "Брандът пише „не ни хареса“ и следващото видео повтаря същите грешки.",
        "belief_shift": "Конкретната причина е насока за следващото видео, а не любезност към отказания.",
        "mechanism": "Причината при отказ в Pactios стига до creator-а и оформя как той изпълнява следващия ти brief.",
        "proof": "Процесен съвет. Не обещавай измерим ръст на качеството от обратната връзка.",
        "cta": "Запази това преди следващия преглед.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Разликата е в едно конкретно изречение.",
        "script": "„Не ни хареса“ не учи никого. „Продуктът се вижда чак в петнайсетата секунда“ учи всички. Добрата причина назовава момента и проблема: късен продукт, неясен звук, обещание, което не искаме. Пишеш го веднъж, а то работи във всяко следващо видео, което получаваш. Това не е учтивост — това е настройка на процеса ти.",
        "duration": 31,
        "visuals": "Две бележки една до друга: размита „не ни хареса“ и конкретна с таймкод. Втората се подчертава.",
        "overlay_text": "Конкретика, не учтивост",
        "audio": "Подчертаващ marker SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Причината днес настройва видеата утре. Запази това преди следващия преглед.",
        "cover": "Как да отказваш полезно",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B39",
        "audience": "brand",
        "title": "Хубаво видео, което не можеш да пуснеш",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да назове болката от съдържание, негодно за употреба заради формат или условия.",
        "pain": "Видеото е чудесно, но е хоризонтално, без права за реклама или с музика, която не може да се излъчва.",
        "belief_shift": "Използваемостта се осигурява в заданието, а не се проверява след получаването.",
        "mechanism": "Pactios brief-ът фиксира формат, условия за използване и ограничения предварително, така че приетото е готово за работа.",
        "proof": "Оперативна болка и превенция. Не давай правен съвет за музикални права.",
        "cta": "Пиши „БРАНД“, ако имаш папка с неизползваеми видеа.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Най-скъпото видео е това, което не можеш да пуснеш.",
        "script": "Видеото е страхотно. Но е хоризонтално, а ти пускаш вертикална реклама. Или музиката е от нечия библиотека. Или „не сме говорили за реклами“. Използваемостта не е късмет — тя е ред в заданието: формат, условия, ограничения, преди първия кадър. Тогава хубавото видео е и работещо видео.",
        "duration": 31,
        "visuals": "Хоризонтално видео, натикано в вертикална рамка с черни ленти. После чисто вертикално видео, което пасва.",
        "overlay_text": "Хубаво ≠ използваемо",
        "audio": "Грешка buzzer, после чист confirm SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Използваемостта се урежда в заданието. Пиши „БРАНД“, ако имаш папка с неизползваеми видеа.",
        "cover": "Папката с мъртви видеа",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B40",
        "audience": "brand",
        "title": "Какво Pactios не е",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Висок",
        "goal": "Да очертае честно границите на продукта и да филтрира несъответстващи очаквания.",
        "pain": "Брандът идва с очакване за медиа агенция, гарантирани резултати или безплатно съдържание и се разочарова.",
        "belief_shift": "Ясната граница на услугата е причина за доверие, а не слабост на предложението.",
        "mechanism": "Pactios е структуриран marketplace за поръчка и приемане на creator съдържание — не медиа агенция и не гаранция за резултат.",
        "proof": "Изброявай само какво продуктът не прави. Внимавай всяка граница да е формулирана точно и без ирония към алтернативите.",
        "cta": "Пиши „БРАНД“, ако това честно ти стига.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Затова нека кажем какво не сме.",
        "script": "Pactios не пуска рекламите ти и не управлява медиа бюджет. Не гарантира виралност, продажби или конкретен брой submissions. Не е място за безплатно съдържание срещу exposure. Pactios е структуриран начин да поръчаш, прегледаш и приемеш creator видеа при ясни условия. Ако търсиш точно това — говорим си.",
        "duration": 32,
        "visuals": "Три таблички с „НЕ“ падат една след друга, после една стабилна табела с това, което е.",
        "overlay_text": "Граници = доверие",
        "audio": "Три тъпи thud SFX, после спокоен тон",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Ясната граница е причина за доверие. Пиши „БРАНД“, ако това честно ти стига.",
        "cover": "Какво НЕ правим",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B41",
        "audience": "brand",
        "title": "Какво прави Pactios — за брандове",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да даде кратко и честно продуктово обяснение от гледната точка на бранда.",
        "pain": "Брандът чува „UGC платформа“ и не разбира какво конкретно се случва от първата до последната стъпка.",
        "belief_shift": "Целият процес е три разбираеми стъпки: задание, изпратени видеа, решение с плащане при приемане.",
        "mechanism": "Брандът публикува brief с reward, creators изпращат видеа, брандът приема исканите и плащането се задейства при приемане.",
        "proof": "Продуктово описание без performance обещания. Не добавяй числа за обем или срокове.",
        "cta": "Пиши „БРАНД“ за ранен достъп.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Ето го целия процес без украса.",
        "script": "Стъпка едно: описваш какво искаш — продукт, ъгъл, забрани, формат — и задаваш възнаграждение. Стъпка две: creators, които харесват заданието, снимат и изпращат. Стъпка три: разглеждаш, приемаш каквото искаш, отказваш с причина останалото. Плащаш при приемане. Това е Pactios — без магия, с ред.",
        "duration": 31,
        "visuals": "Три карти на масата: „Brief“, „Видеа“, „Решение“. Обръщай ги една по една с ръка.",
        "overlay_text": "Brief → Видеа → Решение",
        "audio": "Три card-flip SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Без магия, с ред: brief, видеа, решение. Пиши „БРАНД“ за ранен достъп.",
        "cover": "Pactios в 3 стъпки",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B42",
        "audience": "brand",
        "title": "Вертикално, кратко, с човек в кадър",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да обясни защо форматните изисквания в brief-а не са каприз, а условие за използваемост.",
        "pain": "Брандът получава видеа в грешен формат и дължина и не разбира защо трябва да ги отказва.",
        "belief_shift": "Форматът е част от продукта на видеото — не опаковка, която се оправя после.",
        "mechanism": "Pactios brief-ът фиксира вертикален формат, дължина и присъствие на човек в кадър според употребата на видеото.",
        "proof": "Форматно обяснение за платформите като група. Не цитирай конкретни алгоритмични правила на платформи.",
        "cta": "Запази това като формат ред за brief-а.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Причината е къде живее видеото.",
        "script": "Видеото ще живее на телефон, в вертикален feed, между палец и внимание от три секунди. Затова е вертикално — да запълни екрана. Кратко — да свърши преди търпението. С човек в кадър — защото лице задържа повече от опаковка. Напиши формата в заданието и няма да отказваш видеа по технически причини.",
        "duration": 30,
        "visuals": "Завърти телефон от хоризонтално към вертикално в ръка; видеото запълва екрана и таймер отброява 30 секунди.",
        "overlay_text": "Вертикално · Кратко · Човек",
        "audio": "Rotate whoosh, тих tick на таймера",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Форматът е част от продукта на видеото. Запази това като формат ред за brief-а.",
        "cover": "Форматът не е каприз",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B43",
        "audience": "brand",
        "title": "Защо ранният списък има смисъл",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Конверсия",
        "funnel": "Конверсия",
        "claim_risk": "Среден",
        "goal": "Да даде честна причина брандът да се запише сега, без изкуствен натиск.",
        "pain": "Брандът отлага записването, защото „ранен достъп“ обикновено значи маркетингов трик.",
        "belief_shift": "Ранните брандове получават ред по време на старта и глас върху това как продуктът се доизгражда.",
        "mechanism": "Записаните в списъка получават достъп според реда си при старта и директен канал за обратна връзка към екипа.",
        "proof": "Обещавай само ред на достъп и канал за обратна връзка. Без изкуствен недостиг и без обещания за цени.",
        "cta": "Пиши „БРАНД“ за място в реда.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Затова ето честната сделка.",
        "script": "Няма да ти кажем „остават три места“, защото не е вярно. Вярно е друго: стартът върви по списъка, а ранните брандове говорят директно с екипа, докато продуктът се доизглажда. Записваш се, идваш си на реда, казваш какво ти липсва — и то има шанс да бъде построено. Това е сделката, без фойерверки.",
        "duration": 30,
        "visuals": "Подреден списък с имена, маркер минава по реда. После чат прозорец бранд—екип.",
        "overlay_text": "Ред + глас, без трикове",
        "audio": "Тих marker SFX по списъка",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Ред на достъп и глас към екипа — това е честната сделка. Пиши „БРАНД“ за място в реда.",
        "cover": "Ранният списък, честно",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B44",
        "audience": "brand",
        "title": "Постът изчезва, активът остава",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да премести фокуса от еднократни публикации към трайно използваемо съдържание.",
        "pain": "Брандът плаща за инфлуенсър пост, който потъва във feed-а за ден, и не остава нищо за преизползване.",
        "belief_shift": "Стойността е във видео файла, който можеш да пускаш многократно, а не в еднократния момент на публикация.",
        "mechanism": "Приетите Pactios видеа са активи на бранда за собствените му канали и реклами според условията в brief-а.",
        "proof": "Сравнение на трайност на актива. Не твърди, че инфлуенсър публикациите нямат стойност изобщо.",
        "cta": "Пиши „БРАНД“, ако искаш активи, не моменти.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Въпросът е какво ти остава на следващия ден.",
        "script": "Постът живее ден-два и потъва. Хубав момент — но моментът не се преизползва. Видео файлът в твоята папка е друго: пускаш го в реклама този месец, на сайта следващия, режеш го на части догодина. Едното е събитие, другото е актив. Кампаниите се строят върху активи.",
        "duration": 30,
        "visuals": "Feed, който потъва надолу и изчезва. После папка с файлове, от която видеото се влачи към три различни канала.",
        "overlay_text": "Момент или актив",
        "audio": "Sinking whoosh, после три drag-drop click SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Кампаниите се строят върху активи, не върху моменти. Пиши „БРАНД“, ако искаш активи, не моменти.",
        "cover": "Какво остава утре",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B45",
        "audience": "brand",
        "title": "Какво е честно да очакваш от creators",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да калибрира очакванията на бранда към хората от другата страна на процеса.",
        "pain": "Брандът очаква агенционен акаунт мениджмънт от независим creator и се разочарова от нормални граници.",
        "belief_shift": "Creator-ът дължи добро видео по ясен brief — не денонощна комуникация и безкрайни ревизии.",
        "mechanism": "Pactios рамкира отношението: ясно задание, изпълнение, решение с причина — без скрити очаквания от двете страни.",
        "proof": "Калибриране на очаквания. Не описвай creators като безотказен ресурс и не обещавай конкретно поведение.",
        "cta": "Пиши „БРАНД“, ако търсиш партньорство с ясни граници.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Затова нека кажем какво е честно.",
        "script": "Честно е да очакваш видео по заданието, в срока и във формата. Честно е да получиш професионално изпълнение. Нечестно е да очакваш пет безплатни ревизии, отговор в полунощ и четене на мисли. Ясният brief замества мениджмънта: колкото по-точна е заявката, толкова по-малко комуникация ѝ трябва.",
        "duration": 31,
        "visuals": "Два списъка: „честно“ с три отметки и „нечестно“ с три хикса. Задръж върху ясния brief като мост.",
        "overlay_text": "Ясни очаквания, ясни граници",
        "audio": "Три check и три buzz SFX, меки",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Ясният brief замества мениджмънта. Пиши „БРАНД“, ако търсиш партньорство с ясни граници.",
        "cover": "Честните очаквания",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B46",
        "audience": "brand",
        "title": "Гледай submission-а като зрител",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да научи брандовете да оценяват видеа по първите секунди, а не по вътрешни предпочитания.",
        "pain": "Брандът преглежда видеата като собственик — търси логото и пълния списък ползи — и приема неща, които зрителят скролва.",
        "belief_shift": "Видеото се оценява с палеца на зрителя: ако първите три секунди не задържат, останалото няма значение.",
        "mechanism": "При прегледа в Pactios брандът може да гледа първите секунди на всяко submission точно както зрител би ги видял във feed-а.",
        "proof": "Съвет за оценка. Не обещавай, че силният hook гарантира performance.",
        "cta": "Запази това преди следващия преглед.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Тайната е да гледаш с чужд палец.",
        "script": "Собственикът гледа видеото до края, защото е негово. Зрителят му дава три секунди. Затова при прегледа първо пусни само началото: спря ли те, или посегна към скрола? Логото в първия кадър топли теб, но студи зрителя. Приемай видеата, които биха спрели палеца ти, ако не беше твоят продукт.",
        "duration": 31,
        "visuals": "Гледай видео на телефон с хронометър до него, спрян на третата секунда. Палецът виси над екрана.",
        "overlay_text": "Три секунди истина",
        "audio": "Хронометър click на третата секунда",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Оценявай с палеца на зрителя, не с очите на собственика. Запази това преди следващия преглед.",
        "cover": "Гледай като зрител",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B47",
        "audience": "brand",
        "title": "Слаби социални профили? Кампанията пак работи",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да премахне бариерата „нямаме силно социално присъствие“ пред стартиране на кампания.",
        "pain": "Брандът отлага UGC, защото профилите му са малки и смята, че първо трябва да „порасне“ в социалните.",
        "belief_shift": "Raw UGC видеата не зависят от профила на бранда — те работят в реклами и на сайта дори при нулево социално присъствие.",
        "mechanism": "Приетите Pactios видеа се използват в платени канали и собствени страници, независимо от размера на профилите на бранда.",
        "proof": "Продуктова употреба на актива. Не обещавай рекламни резултати и не съветвай за медиа стратегия.",
        "cta": "Пиши „БРАНД“, дори профилът ти да спи.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Хубавата новина: видеото не пита колко followers имаш.",
        "script": "„Първо да си вдигнем профила, после UGC“ е ред, който не съществува. Видеото не живее само във feed-а ти — то работи в реклама, на продуктовата страница, в имейл. Тези места не питат колко followers имаш. Съдържанието може да е първата тухла на присъствието, а не наградата след него.",
        "duration": 30,
        "visuals": "Профил с малко число последователи, после същото видео поставено в реклама и продуктова страница.",
        "overlay_text": "Видеото не пита за followers",
        "audio": "Неутрален click при всяко поставяне",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Съдържанието е първата тухла, не наградата. Пиши „БРАНД“, дори профилът ти да спи.",
        "cover": "Без голям профил? Ок.",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B48",
        "audience": "brand",
        "title": "Кога UGC не е правилният избор",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Среден",
        "goal": "Да спечели доверие, като честно опише случаите, в които форматът не е подходящ.",
        "pain": "Брандът опитва UGC за неподходящ случай, проваля се и отписва формата завинаги.",
        "belief_shift": "Форматът има граници и познаването им е част от умението да го използваш.",
        "mechanism": "Pactios е за кратки човешки видеа по brief — не за сложни B2B демонстрации, корпоративни филми или строго регулирани клейми.",
        "proof": "Честна дисквалификация. Формулирай границите като характер на формата, не като правен съвет за регулирани индустрии.",
        "cta": "Пиши „БРАНД“, ако случаят ти е за формата.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Затова нека кажем кога да не ни търсиш.",
        "script": "Ако продуктът ти иска четиридесет минути техническо демо пред инженерен борд — това не е UGC. Ако посланието ти изисква прецизно одобрен регулиран текст дума по дума — кратката човешка реч не е форматът. UGC блести при ежедневни продукти, видим резултат и човешка препоръка. Знанието кога „не“ пази бюджета ти за случаите „да“.",
        "duration": 32,
        "visuals": "Три врати с надписи; две се затварят спокойно, третата — с ежедневен продукт — се отваря.",
        "overlay_text": "Форматът има граници",
        "audio": "Две меки затваряния, едно отваряне",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Да знаеш кога „не“ пази бюджета за „да“. Пиши „БРАНД“, ако случаят ти е за формата.",
        "cover": "Кога НЕ ползвай UGC",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B49",
        "audience": "brand",
        "title": "Пет ревизии по имейл по-късно",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да назове болката от безкрайните ревизионни цикли и да ѝ противопостави структурата приемане/отказ.",
        "pain": "Брандът и creator-ът си разменят версии и коментари седмици наред, а видеото така и не става „готово“.",
        "belief_shift": "Ясното решение с причина е по-бързо и по-честно от безкрайното дошлифоване по имейл.",
        "mechanism": "В Pactios брандът приема или отказва submission с причина, вместо да управлява ревизионни цикли.",
        "proof": "Процесно сравнение. Не твърди, че ревизиите са винаги излишни или че отказът винаги е по-добър.",
        "cta": "Пиши „БРАНД“, ако „финална версия 7“ ти е позната.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Познаваш файла „финална_версия_7_НАИСТИНА“.",
        "script": "Ревизия едно: смени музиката. Ревизия три: върни старата. Ревизия пет: никой вече не помни какво искаше. Безкрайното дошлифоване изтощава и двете страни и рядко ражда по-добро видео. Другият модел е решение: това работи — приемам; това не — ето защо. Следващото видео идва по-точно, без археология в пощата.",
        "duration": 31,
        "visuals": "Имейл нишка, която расте безкрайно на екрана, после два големи бутона: приеми / откажи с причина.",
        "overlay_text": "Решение > ревизия №7",
        "audio": "Наслагващи се notification SFX, после един чист click",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Ясното решение е по-бързо от безкрайното дошлифоване. Пиши „БРАНД“, ако „финална версия 7“ ти е позната.",
        "cover": "Финална_версия_7.mp4",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "B50",
        "audience": "brand",
        "title": "Какво получаваш в ранния достъп",
        "batch": "BRAND-02",
        "status": "Идея",
        "pillar": "Конверсия",
        "funnel": "Конверсия",
        "claim_risk": "Нисък",
        "goal": "Да опише конкретно съдържанието на ранния достъп за брандове и да затвори решението за записване.",
        "pain": "Брандът се колебае да остави контакт, защото не знае какво реално стои зад „ранен достъп“.",
        "belief_shift": "Записването е конкретна стъпка с ясно съдържание, а не абонамент за неясни имейли.",
        "mechanism": "Ранният списък дава ред при старта, помощ при първия brief и директна връзка с екипа на Pactios.",
        "proof": "Изброявай само реално планираното за ранните брандове. Без обещания за цени, отстъпки или срокове на старта.",
        "cta": "Пиши „БРАНД“ и си в списъка.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Ето какво точно стои зад думите „ранен достъп“.",
        "script": "Пишеш „БРАНД“ и влизаш в списъка — това е цялата процедура. Какво следва: достъп по реда на записване, когато платформата отвори. Помощ от екипа за първия ти brief, за да не тръгнеш със скучно задание. И директен канал за въпроси, без чатбот лабиринти. Толкова. Решаваш дали ти върши работа.",
        "duration": 30,
        "visuals": "Три реда на екран, отмятани един по един: ред, помощ за brief, директен канал. Без блясък.",
        "overlay_text": "Ред · Помощ · Канал",
        "audio": "Три чисти check SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Ред при старта, помощ за първия brief, директен канал. Пиши „БРАНД“ и си в списъка.",
        "cover": "Ранният достъп, конкретно",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C01",
        "audience": "creator",
        "title": "Followers не са единствената ти стойност",
        "batch": "CREATOR-01",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да привлече capable raw-UGC creators, които нямат голяма аудитория.",
        "pain": "Начинаещият creator приема, че без много followers няма място в brand campaign.",
        "belief_shift": "При raw UGC брандът може да купува качеството на видеото, не достъпа до аудиторията.",
        "mechanism": "Pactios brief-овете оценяват fit, изпълнение, reliability и acceptance, а posting може изобщо да не е част от задачата.",
        "proof": "Не казвай „followers никога нямат значение“; това зависи от campaign type.",
        "cta": "Пиши „КРИЕЙТЪР“ за ранен достъп.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Добрата новина: не всяка кампания купува аудиторията ти.",
        "script": "При raw UGC брандът може да търси самото видео, без да иска публикация в профила ти. Тогава са важни ясната реч, добрият кадър, следването на brief-а и срокът. Followers могат да имат значение в други кампании, но не са единствената ти валута.",
        "duration": 31,
        "visuals": "Покажи follower counter, избутай го встрани и постави отпред четири качества.",
        "overlay_text": "Качество > vanity number",
        "audio": "Counter down SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "За raw UGC видеото може да е продуктът, не аудиторията ти.",
        "cover": "Не ти трябват хиляди followers",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "C02",
        "audience": "creator",
        "title": "Плащане след приемане — не гаранция за submission",
        "batch": "CREATOR-01",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Висок",
        "goal": "Да обясни честно speculative risk-а преди creator signup.",
        "pain": "Creator може да инвестира време в submission, което брандът не приема.",
        "belief_shift": "Pactios не трябва да маскира риска; добрият creator решава дали reward и brief си струват усилието.",
        "mechanism": "Reward се задейства при acceptance според campaign terms; платформата трябва да показва reward, права, срок и acceptance context предварително.",
        "proof": "Изисква правно одобрени campaign terms. Не използвай „гарантирано плащане“ за неприето съдържание.",
        "cta": "Пиши „КРИЕЙТЪР“, ако искаш прозрачни условия.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Сега честната част, която други платформи може да скрият.",
        "script": "Изпратеното видео не означава автоматично плащане. При този тип кампания брандът плаща за съдържанието, което приеме. Затова преди да снимаш трябва да виждаш reward-а, brief-а, правата и критерия за приемане. Pactios не трябва да превръща риска ти в дребен шрифт.",
        "duration": 32,
        "visuals": "Покажи голям „submission“, после отделен „accepted“ stamp; условията стоят видими през целия кадър.",
        "overlay_text": "Submission ≠ automatic payment",
        "audio": "Stamp SFX само при acceptance",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Честният marketplace показва риска преди снимането.",
        "cover": "Кога точно се плаща",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "C03",
        "audience": "creator",
        "title": "Виж reward-а преди да снимаш",
        "batch": "CREATOR-01",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да продава прозрачността на brief-а и reward-а.",
        "pain": "Creator често получава неясно запитване и разбира бюджета след дълъг разговор.",
        "belief_shift": "Решението дали да участваш трябва да се взема с видима задача и видимо възнаграждение.",
        "mechanism": "Pactios campaign card показва brief, creator reward, права, срок и acceptance правила.",
        "proof": "Продуктов contract. Не обещавай, че всеки brief ще бъде икономически привлекателен.",
        "cta": "Пиши „КРИЕЙТЪР“ за ранния списък.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Преди да включиш камерата, трябва да знаеш това.",
        "script": "Какъв е продуктът? Какво трябва да заснемеш? Какви права се искат? Кога е срокът? И колко получаваш, ако съдържанието бъде прието? В Pactios тази информация трябва да е видима преди да решиш дали задачата си заслужава.",
        "duration": 29,
        "visuals": "Посочвай пет checklist елемента един по един.",
        "overlay_text": "Brief • Reward • Rights • Deadline",
        "audio": "Five soft ticks",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Не снимай срещу неизвестни условия.",
        "cover": "Виж условията първо",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "C04",
        "audience": "creator",
        "title": "Креативността не отменя brief-а",
        "batch": "CREATOR-01",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да подобри creator quality и acceptance probability.",
        "pain": "Creator прави визуално интересно видео, което пропуска задължителните елементи.",
        "belief_shift": "Професионализмът е собствен стил вътре в рамката на задачата.",
        "mechanism": "Structured brief и rejection reason, свързана с brief compliance.",
        "proof": "Образователно твърдение; по-късно добави реален анонимизиран acceptance example.",
        "cta": "Запази това преди следващия brief.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Най-креативният кадър не спасява грешния deliverable.",
        "script": "Брандът не търси само красиво видео. Търси конкретни кадри, послание, дължина и правилно показан продукт. Професионалният creator първо изпълнява brief-а, после добавя собствен стил. Ако обърнеш реда, може да направиш чудесно видео за напълно различна задача.",
        "duration": 31,
        "visuals": "Покажи красив кадър с червен X, после прост checklist с зелени отметки.",
        "overlay_text": "Стил вътре в brief-а",
        "audio": "Record scratch при червения X",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Креативността е плюс. Brief compliance е основата.",
        "cover": "Красиво, но грешно",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "C05",
        "audience": "creator",
        "title": "Отказът трябва да има причина",
        "batch": "CREATOR-01",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Среден",
        "goal": "Да покаже fairness guardrail-а на marketplace-а.",
        "pain": "Creator получава „не ни харесва“ без връзка с предварителните условия.",
        "belief_shift": "Отказът не трябва да бъде произволен; той трябва да посочва brief mismatch.",
        "mechanism": "Pactios планира structured rejection reason и feedback, свързан с brief compliance.",
        "proof": "Product rule, който изисква operational и legal validation.",
        "cta": "Пиши „КРИЕЙТЪР“, ако искаш по-ясни правила.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "„Не ми харесва“ не е полезна обратна връзка.",
        "script": "Ако брандът откаже submission, причината трябва да е свързана с предварително видимия brief: липсва кадър, грешно твърдение, неправилен формат или друг конкретен miss. Pactios планира структуриран отказ, за да можеш да разбереш какво реално не е изпълнено.",
        "duration": 30,
        "visuals": "Покажи „не ми харесва“, разкъсай го и изведи четири конкретни rejection reasons.",
        "overlay_text": "Причина, не настроение",
        "audio": "Paper crumple SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Marketplace без ясни причини за отказ губи добрите creators.",
        "cover": "Отказът има причина",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "C06",
        "audience": "creator",
        "title": "Няма обещание за постоянни кампании",
        "batch": "CREATOR-01",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да зададе честна expectation boundary и да намали неподходящи signup очаквания.",
        "pain": "Маркетингът на creator платформи често звучи като гарантиран постоянен доход.",
        "belief_shift": "Ранната платформа може да предлага възможности, но не може честно да гарантира тяхната честота или приемане.",
        "mechanism": "Campaign fit зависи от категория, наличност, brief, reward и brand demand.",
        "proof": "Изрична граница. След launch добави реална campaign frequency статистика.",
        "cta": "Пиши „КРИЕЙТЪР“, ако предпочиташ честни очаквания.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Pactios няма да ти обещае постоянна работа.",
        "script": "Това би било лъжа. Кампаниите зависят от реални брандове, категории, бюджети и търсене. Pactios може да ти показва подходящи briefs и ясни условия. Твоята работа е да поддържаш силни примери и да изпълняваш надеждно. Възможност не означава гаранция.",
        "duration": 30,
        "visuals": "Статичен директен кадър; без комедиен ефект в първата половина.",
        "overlay_text": "Възможност ≠ гаранция",
        "audio": "Без SFX; чист глас",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Ранният marketplace не трябва да продава измислен постоянен доход.",
        "cover": "Без фалшиви обещания",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "C07",
        "audience": "creator",
        "title": "Три силни примера са достатъчни за начало",
        "batch": "CREATOR-01",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да превърне пасивен интерес в конкретна creator preparation action.",
        "pain": "Начинаещият creator отлага кандидатстването, защото няма голямо портфолио.",
        "belief_shift": "Малко, целево портфолио доказва повече от много случайни клипове.",
        "mechanism": "Pactios creator profile трябва да показва релевантни samples и category fit.",
        "proof": "Практическа препоръка, не гаранция за приемане.",
        "cta": "Запази видеото и заснеми първия пример.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Портфолиото ти не трябва да има сто видеа.",
        "script": "За начало направи три ясни примера: продуктово демо, проблем и решение, и кратко testimonial видео. Покажи чист звук, естествено говорене и правилно заснет продукт. Три целеви примера са по-полезни от двадесет клипа, които не показват как изпълняваш brief.",
        "duration": 31,
        "visuals": "Покажи три numbered frames с различен тип sample.",
        "overlay_text": "Demo • Problem/Solution • Testimonial",
        "audio": "Three-count SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Започни с три samples, които доказват различни умения.",
        "cover": "Първите ти 3 UGC видеа",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "C08",
        "audience": "creator",
        "title": "Естественият български е предимство",
        "batch": "CREATOR-01",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да привлече creators, които звучат естествено на местния пазар.",
        "pain": "Creators имитират преведена англоезична ad delivery и звучат неестествено.",
        "belief_shift": "Локалната интонация и разговорен език са част от creative value.",
        "mechanism": "Pactios е Bulgarian-first marketplace.",
        "proof": "Не обещавай по-висока conversion rate без real test.",
        "cta": "Пиши „КРИЕЙТЪР“, ако снимаш естествено на български.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Да говориш естествено на български е реално предимство.",
        "script": "Брандът може да преведе текст. Много по-трудно е да преведе естествената интонация, местните изрази и начина, по който хората действително говорят. Не се опитвай да звучиш като лош дублаж на чужда реклама. Звучи като човек, на когото българската аудитория би повярвала.",
        "duration": 31,
        "visuals": "Първа реплика с преувеличен dub voice, после естествен delivery.",
        "overlay_text": "Не звучи като превод",
        "audio": "Dub filter, после clean voice",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Локалният UGC започва от начина, по който реално говорим.",
        "cover": "Говори като човек",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "C09",
        "audience": "creator",
        "title": "Надеждността те наема повторно",
        "batch": "CREATOR-01",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да подобри delivery reliability и creator repeat rate.",
        "pain": "Creator се фокусира върху ефекти, но закъснява, изпраща грешен файл или игнорира условия.",
        "belief_shift": "Творчеството привлича внимание; надеждността изгражда повторно търсене.",
        "mechanism": "Pactios записва срок, submission, acceptance и operational history.",
        "proof": "След реални кампании добави repeat-rate data; дотогава остани при общия професионален принцип.",
        "cta": "Запази това като checklist за следващия submission.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Знаеш ли кое те прави по-ценен от още един transition effect?",
        "script": "Отговаряш навреме. Спазваш срока. Изпращаш правилния формат. Следваш brief-а и именуваш файла така, че някой да го намери. Ефектът може да привлече вниманието на бранда. Надеждността е причината да те потърси отново.",
        "duration": 30,
        "visuals": "Checklist се отбелязва в ритъм; финален кадър с правилно име на файл.",
        "overlay_text": "Срок • Формат • Brief • File",
        "audio": "Checklist ticks",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Професионализмът е част от creator продукта.",
        "cover": "Как те наемат отново",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "C10",
        "audience": "creator",
        "title": "Какво всъщност прави Pactios",
        "batch": "CREATOR-01",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Конверсия",
        "claim_risk": "Среден",
        "goal": "Да даде кратък и честен creator-side product explanation.",
        "pain": "Creator не разбира дали Pactios е агенция, социална мрежа или списък за influencer deals.",
        "belief_shift": "Pactios е marketplace workflow за briefs, submissions, acceptance и compensation records.",
        "mechanism": "Brand posts brief/reward; creator decides whether to submit; brand accepts; platform records the transaction and rights flow.",
        "proof": "Не представяй launch-stage capabilities като вече доказан мащаб или liquidity.",
        "cta": "Пиши „КРИЕЙТЪР“ за ранен достъп.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Pactios не е школа и не е поредната influencer група.",
        "script": "Pactios е място, където бранд публикува конкретен brief и reward, а подходящите creators решават дали да изпратят съдържание. Брандът приема желаните активи, а условията, правата и плащането следват този записан процес. В началото търсим качествени български creators, не огромна цифра регистрации.",
        "duration": 33,
        "visuals": "Четири последователни физически етикета: Brief, Submit, Accept, Pay.",
        "overlay_text": "Brief → Submit → Accept → Pay",
        "audio": "Four-step progress SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Pactios свързва реална brand задача с creator submission и ясно приемане.",
        "cover": "Как работи Pactios",
        "post_url": "",
        "learning": "",
        "created_at": "2026-07-31T00:00:00.000Z",
        "updated_at": "2026-07-31T00:00:00.000Z"
      },
      {
        "id": "C11",
        "audience": "creator",
        "title": "Телефонът ти стига за старт",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да премахне бариерата „нямам техника“ пред първото creator видео.",
        "pain": "Начинаещият отлага първото видео, защото чака камера, микрофон и осветление, които не може да си позволи.",
        "belief_shift": "Raw UGC се снима с телефона, който вече е в джоба ти — техниката не е входният праг.",
        "mechanism": "Pactios brief-овете за raw UGC очакват естествено телефонно видео, не студийна продукция.",
        "proof": "Говори за достатъчност на телефона за формата. Не твърди, че техниката никога няма значение.",
        "cta": "Пиши „КРИЕЙТЪР“, ако телефонът ти е готов.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Лошата новина за извиненията: тя е в джоба ти.",
        "script": "Списъкът „като си купя камера, микрофон и лампа“ е удобно скривалище. Форматът, който брандовете търсят тук, е телефонно видео: истинска стая, истинска светлина, истински човек. Телефонът от последните няколко години снима повече от достатъчно. Започваш с това, което имаш, или не започваш изобщо.",
        "duration": 30,
        "visuals": "Извади телефон от джоба бавно и го постави на импровизирана стойка от книги. Натисни запис.",
        "overlay_text": "Техниката е в джоба ти",
        "audio": "Кратък record beep при натискането",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Започваш с това, което имаш. Пиши „КРИЕЙТЪР“, ако телефонът ти е готов.",
        "cover": "Стига ти телефонът",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C12",
        "audience": "creator",
        "title": "Първите три секунди решават",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да научи creators да строят видеото около силно начало.",
        "pain": "Creator-ът снима добро видео, което никой не гледа, защото започва с „здравейте, днес ще ви покажа“.",
        "belief_shift": "Началото не е въведение, а причината зрителят да остане — влизаш направо в най-силното.",
        "mechanism": "Pactios brief-овете задават hook цел, защото брандовете оценяват видеата по началото им — както зрителите.",
        "proof": "Структурен съвет за формата. Не обещавай, че силният hook гарантира приемане или гледания.",
        "cta": "Запази това преди следващия дубъл.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Затова започни от края на търпението.",
        "script": "Никой не изчаква въведението. „Здравейте, аз съм…“ е скролнато, преди да си казал името. Започни от най-силното: резултатът, проблемът, изненадата — първо то, обяснението после. Представи си, че имаш само три секунди, защото имаш точно толкова. Останалото видео съществува само ако началото го заслужи.",
        "duration": 30,
        "visuals": "Покажи два старта на едно видео: с въведение и направо с резултата. Задраскай първия с пръст по екрана.",
        "overlay_text": "Започни от силното",
        "audio": "Swipe SFX върху скучния старт",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Видеото съществува само ако началото го заслужи. Запази това преди следващия дубъл.",
        "cover": "3 секунди решават",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C13",
        "audience": "creator",
        "title": "Brief-ът ти казва какво да снимаш",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да покаже, че структурираното задание премахва гадаенето от creator работата.",
        "pain": "Creator-ът получава „снимай нещо за продукта“ и после търпи откази, защото очакванията са били другаде.",
        "belief_shift": "Ясното задание е защита за creator-а: знаеш какво се иска, преди да инвестираш време.",
        "mechanism": "Pactios brief-ът описва продукт, ъгъл, забранени твърдения, формат и срок — всичко видимо преди участие.",
        "proof": "Продуктова механика. Не обещавай, че ясният brief гарантира приемане.",
        "cta": "Пиши „КРИЕЙТЪР“, ако ти омръзна да гадаеш.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Разликата е, че тук заданието е написано.",
        "script": "Най-лошата задача е неясната: „направи нещо готино“. Снимаш, предаваш и чуваш „не това имахме предвид“. В Pactios заданието е конкретно: какъв продукт, какъв ъгъл, какво не бива да казваш, какъв формат, до кога. Четеш и решаваш дали е за теб. Гадаенето не е част от работата.",
        "duration": 30,
        "visuals": "Покажи размазан имейл с една обща фраза, после структуриран brief с пет ясни реда.",
        "overlay_text": "Написано, не намекнато",
        "audio": "Blur-to-focus SFX при смяната",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Знаеш какво се иска, преди да инвестираш време. Пиши „КРИЕЙТЪР“, ако ти омръзна да гадаеш.",
        "cover": "Край на гадаенето",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C14",
        "audience": "creator",
        "title": "Кога получаваш парите си",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Среден",
        "goal": "Да обясни честно момента на плащане и връзката му с приемането.",
        "pain": "Creator-ът е гонил хонорари с месеци и не вярва на обещания за плащане без конкретика.",
        "belief_shift": "Плащането е обвързано с ясно събитие — приемането на видеото — а не с настроението на клиента.",
        "mechanism": "В Pactios приемането на submission задейства creator compensation по условията, видими в brief-а предварително.",
        "proof": "Обясни събитието, което задейства плащането. Не назовавай срокове в дни и не обещавай плащане при неприето видео.",
        "cta": "Пиши „КРИЕЙТЪР“, ако си гонил хонорар.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Затова въпросът „кога“ има точен отговор.",
        "script": "Всеки, който е работил на свободна практика, е гонил пари: „следващата седмица“, после тишина. Тук моментът е дефиниран: брандът приема видеото ти и това приемане задейства възнаграждението по условията от brief-а. Не е обещание на човек — правило на платформата. Ако видеото не бъде прието, плащане няма — това също е казано отпред.",
        "duration": 32,
        "visuals": "Таймлайн с една отбелязана точка: „прието“. Стрелка от нея към възнаграждението.",
        "overlay_text": "Прието → платено",
        "audio": "Чист confirm SFX на точката",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Плащането е правило на платформата, не обещание на човек. Пиши „КРИЕЙТЪР“, ако си гонил хонорар.",
        "cover": "Кога идват парите",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C15",
        "audience": "creator",
        "title": "Прозорецът бие ринг лампата",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да даде най-простото решение за светлина без бюджет.",
        "pain": "Creator-ът снима срещу прозореца или под жълта крушка и видеото изглежда аматьорско по грешните причини.",
        "belief_shift": "Добрата светлина е въпрос на позиция, а не на оборудване.",
        "mechanism": "Pactios brief-овете очакват четимо, естествено видео — а дневната светлина от прозорец е най-достъпният начин.",
        "proof": "Практически съвет. Не твърди, че осветлението няма никакво значение.",
        "cta": "Запази това преди следващия дубъл.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Най-добрата ти лампа е безплатна.",
        "script": "Правилото е едно изречение: заставаш с лице към прозореца, не с гръб. Светлината пада върху лицето ти и кадърът омеква. Гръб към прозореца — ставаш силует. Жълта крушка отгоре — ставаш уморен. Дневна светлина отпред, телефон на нивото на очите — и видеото изглежда чисто без нито лев за техника.",
        "duration": 29,
        "visuals": "Два кадъра за секунди: гръб към прозореца (тъмен силует), после лице към прозореца (чист кадър).",
        "overlay_text": "Лице към прозореца",
        "audio": "Мек light-switch SFX между кадрите",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Добрата светлина е позиция, не оборудване. Запази това преди следващия дубъл.",
        "cover": "Безплатната лампа",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C16",
        "audience": "creator",
        "title": "Година снимаш „за exposure“",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да назове експлоатацията чрез обещания за видимост и да предложи платен модел.",
        "pain": "Creator-ът прави безплатно съдържание за брандове срещу „ще те покажем“, което не плаща нищо.",
        "belief_shift": "Работата за бранд е труд със стойност, а видимостта не е валута.",
        "mechanism": "Pactios brief-овете идват с обявен reward — задача без възнаграждение просто не съществува в системата.",
        "proof": "Назови модела честно. Не обещавай конкретни доходи и не твърди, че всяко безплатно сътрудничество е грешка.",
        "cta": "Пиши „КРИЕЙТЪР“, ако exposure не ти плаща наема.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Да си направим сметката на exposure-а.",
        "script": "„Нямаме бюджет, но ще те тагнем“ — и ти снимаш ден за нечия реклама срещу споменаване. Година по-късно: много exposure, нула лева. Трудът за бранд е услуга, а услугите имат цена. Затова тук всяко задание идва с обявено възнаграждение, преди да си вдигнал телефона. Ако няма цена, няма задание.",
        "duration": 31,
        "visuals": "Сметка на лист: „exposure“ + „exposure“ = 0 лв. После brief с видимо възнаграждение.",
        "overlay_text": "Exposure не е валута",
        "audio": "Калкулаторни click SFX, после чист cash SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Трудът за бранд е услуга, а услугите имат цена. Пиши „КРИЕЙТЪР“, ако exposure не ти плаща наема.",
        "cover": "Стига безплатно",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C17",
        "audience": "creator",
        "title": "Прочети забраните преди първия дубъл",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да намали отказите, породени от неспазени ограничения в заданието.",
        "pain": "Creator-ът снима убедително видео с обещание, което brief-ът изрично забранява, и получава отказ.",
        "belief_shift": "Забраните не са дребен шрифт, а най-бързият списък „как да не ми откажат видеото“.",
        "mechanism": "Pactios brief-ът изброява забранените твърдения и creator-ът ги вижда преди заснемането.",
        "proof": "Процесен съвет. Не давай правни съвети за конкретни категории продукти.",
        "cta": "Запази това преди следващото задание.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Най-честият отказ се пише преди първия дубъл.",
        "script": "Искаш видеото да звучи силно и казваш „гарантирано действа“. А в заданието пише: без гаранции. Видеото е добро, отказът е сигурен. Забраните са там, защото брандът отговаря за думите в рекламата си. Прочети ги първи, не последни — те са чеклистът „как да не ми откажат“. После снимай смело в рамките.",
        "duration": 31,
        "visuals": "Пръст минава по секцията „Не казвай“ в brief-а, после запис със спокойно кимване.",
        "overlay_text": "Първо забраните",
        "audio": "Тих paper slide SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Забраните са чеклистът „как да не ми откажат“. Запази това преди следващото задание.",
        "cover": "Прочети преди запис",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C18",
        "audience": "creator",
        "title": "Какво всъщност е raw UGC",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да дефинира формата, за да знаят creators какво точно продават.",
        "pain": "Creator-ът бърка raw UGC с influencer постове и лъскави edit-и и предлага грешното нещо.",
        "belief_shift": "Raw UGC е естествено видео за каналите на бранда — без твоя публикация, без тежък монтаж.",
        "mechanism": "Pactios raw UGC заданията искат телефонен кадър, естествена реч и следване на brief — файлът отива при бранда.",
        "proof": "Дефиниция на формата. Не омаловажавай другите формати — те са различни услуги.",
        "cta": "Пиши „КРИЕЙТЪР“, ако форматът ти пасва.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Затова нека кажем какво точно продаваш.",
        "script": "Raw UGC не е пост в твоя профил и не е кино монтаж. Това е видео, което изглежда като заснето от приятел: телефон, истинска стая, естествена реч, продуктът в действие. Брандът го взима за своите канали и реклами. Ти продаваш изпълнение — ясно кадриране, честен тон, следване на задание. Това е целият формат.",
        "duration": 31,
        "visuals": "Снимай „видео във видеото“: телефон на стойка, ти говориш естествено, после файлът се влачи към папка „Бранд“.",
        "overlay_text": "Файл за бранда, не пост",
        "audio": "Спокоен room tone, drag-drop click в края",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Продаваш изпълнение, не аудитория. Пиши „КРИЕЙТЪР“, ако форматът ти пасва.",
        "cover": "Raw UGC = какво?",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C19",
        "audience": "creator",
        "title": "Отказаното видео остава твое",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Среден",
        "goal": "Да отговори на страха какво става с труда при отказ.",
        "pain": "Creator-ът се притеснява, че брандът ще използва отказаното видео, без да плати за него.",
        "belief_shift": "Отказът връща правата при теб: неприетото видео не е собственост на бранда.",
        "mechanism": "В Pactios условията от brief-а важат за приетите видеа; отказаното submission не дава права на бранда върху съдържанието.",
        "proof": "Обяснявай платформеното правило просто. Не давай правен съвет и не навлизай в частни случаи.",
        "cta": "Пиши „КРИЕЙТЪР“, ако този страх те е спирал.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Въпросът, който всички задават тихо: а ако откажат?",
        "script": "Страхът е логичен: снимаш, изпращаш, отказват ти — и после виждаш кадрите си в нечия реклама? Не. Правилата тук са прости: брандът получава права върху видеото, което е приел и платил. Отказаното е твое — портфолио, друг brief, каквото решиш. Трудът ти не става безплатен заради едно „не“.",
        "duration": 30,
        "visuals": "Два файла на екран: приетият отива в папка „Бранд“, отказаният се връща в папка „Мои“.",
        "overlay_text": "Отказано = твое",
        "audio": "Два различни move SFX — навън и обратно",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Брандът получава права само върху приетото. Пиши „КРИЕЙТЪР“, ако този страх те е спирал.",
        "cover": "А ако ми откажат?",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C20",
        "audience": "creator",
        "title": "Говори като на приятел",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да освободи creators от рекламния глас и да ги върне към естествената реч.",
        "pain": "Пред камерата creator-ът превключва на „телевизионен водещ“ и видеото губи точно това, за което е поръчано.",
        "belief_shift": "Брандът плаща за естествения ти глас — рекламният тон е дефект, не професионализъм.",
        "mechanism": "Raw UGC brief-овете в Pactios търсят реч като в разговор, защото тя прави съдържанието достоверно.",
        "proof": "Съвет за изпълнение. Не обещавай, че естественият тон гарантира приемане.",
        "cta": "Запази това преди следващия запис.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Представи си, че разказваш на приятел, не на нация.",
        "script": "Камерата се включва и гласът ти става с половин октава по-висок: „Здравейте, скъпи зрители!“ Стоп. Никой не говори така на приятел. Разкажи за продукта, както би разказал на човек на кафе: същите думи, същите паузи, същото свиване на рамене. Странното е, че „непрофесионалното“ говорене е точно професионализмът в този формат.",
        "duration": 30,
        "visuals": "Два дубъла: пресилен рекламен тон, после same кадър с нормална реч и жест с чаша кафе.",
        "overlay_text": "Кафе глас, не ТВ глас",
        "audio": "Rewind SFX между двата дубъла",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Естественият глас е професионализмът на формата. Запази това преди следващия запис.",
        "cover": "Говори нормално",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C21",
        "audience": "creator",
        "title": "Преговори в DM, които не стигат доникъде",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да противопостави хаотичните лични преговори на структурираните условия в платформата.",
        "pain": "Creator-ът губи дни в DM пазарлъци за цена, условия и срокове, които после никой не спазва.",
        "belief_shift": "Условията трябва да съществуват преди разговора, а не да се раждат в него.",
        "mechanism": "В Pactios reward, срок и условия стоят в brief-а — creator-ът избира задача, не води преговори.",
        "proof": "Процесно сравнение. Не твърди, че директните отношения с брандове са винаги лоши.",
        "cta": "Пиши „КРИЕЙТЪР“, ако DM пазарлъците ти омръзнаха.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Проблемът на DM сделката е, че всичко е мъгла.",
        "script": "Ден първи: „какъв ти е рейтът?“ Ден трети: „а може ли по-евтино?“ Ден седми: тишина. DM преговорите изяждат време, а накрая условията пак са устни. Тук е обратното: задачата идва с цена, срок и правила, написани преди да кажеш „да“. Четеш, преценяваш, участваш. Пазарлъкът просто липсва.",
        "duration": 31,
        "visuals": "Скролвай дълъг DM разговор с дати, после един brief екран с трите реда: reward, срок, условия.",
        "overlay_text": "Условия преди разговора",
        "audio": "Множество message SFX, после един чист tone",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Задачата идва с цена, срок и правила. Пиши „КРИЕЙТЪР“, ако DM пазарлъците ти омръзнаха.",
        "cover": "Край на пазарлъка",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C22",
        "audience": "creator",
        "title": "Чеклист преди изпращане",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да даде кратка проверка, която сваля техническите откази.",
        "pain": "Creator-ът изпраща видео с тих звук, грешен формат или пропусната точка от brief-а и получава отказ за дреболия.",
        "belief_shift": "Едноминутната проверка преди изпращане пази труда от откази по технически причини.",
        "mechanism": "Pactios submissions се оценяват срещу brief-а — проверката по неговите точки е най-евтината застраховка.",
        "proof": "Практически чеклист. Не обещавай, че проверката гарантира приемане.",
        "cta": "Запази това като checklist преди изпращане.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Минута проверка пази ден труд.",
        "script": "Преди да натиснеш „изпрати“, провери четири неща. Звук: чува ли се речта чисто на слушалки? Формат: вертикално ли е и в дължината от заданието? Brief: изпълнени ли са изискванията ред по ред, без забранени думи? Начало: първите три секунди задържат ли? Четири отговора „да“ — изпращай спокойно.",
        "duration": 31,
        "visuals": "Четири квадратчета на екран, отмятани с пръст: звук, формат, brief, начало. После бутон „изпрати“.",
        "overlay_text": "Звук · Формат · Brief · Старт",
        "audio": "Четири check SFX, после send whoosh",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Минута проверка пази ден труд. Запази това като checklist преди изпращане.",
        "cover": "Провери 4 неща",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C23",
        "audience": "creator",
        "title": "Не ти трябва агент",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да покаже, че достъпът до брандове не минава през посредници и връзки.",
        "pain": "Creator-ът смята, че brand сделките са за хора с мениджъри, агенции и лични контакти.",
        "belief_shift": "Структурираният marketplace прави достъпа директен: заданията са публични, не са по познанство.",
        "mechanism": "Pactios показва brief-овете на всички creators в платформата — участието зависи от изпълнението, не от контакти.",
        "proof": "Достъпност на модела. Не обещавай приемане и не твърди, че агенциите са излишни за всякакви кариери.",
        "cta": "Пиши „КРИЕЙТЪР“, дори никого да не познаваш.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Тайната е, че врата всъщност няма.",
        "script": "Изглежда, че brand работата е клуб: трябва ти мениджър, познат в агенция, покана. Тук клубът е списък със задания, видим за всеки в платформата. Четеш brief, снимаш, изпращаш — и брандът оценява видеото, не визитката ти. Връзките помагат в живота, но тук входът е изпълнението.",
        "duration": 30,
        "visuals": "Врата с надпис „само с покана“, която се оказва нарисувана на стена. До нея — отворен списък със задания.",
        "overlay_text": "Входът е изпълнението",
        "audio": "Кратък comic knock, после отваряне на списък",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Брандът оценява видеото, не визитката. Пиши „КРИЕЙТЪР“, дори никого да не познаваш.",
        "cover": "Без агент, без връзки",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C24",
        "audience": "creator",
        "title": "Как се формира reward-ът",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Конверсия",
        "claim_risk": "Среден",
        "goal": "Да обясни механиката на възнаграждението, без да обещава конкретни суми.",
        "pain": "Creator-ът не знае колко „се изкарва“ и подозира, че истината се крие нарочно.",
        "belief_shift": "Няма скрита тарифа: всяко задание обявява своята цена и ти решаваш дали усилието си струва.",
        "mechanism": "Брандът задава reward per прието видео в brief-а; creator-ът вижда сумата преди участие и няма скрити удръжки от нея по време на кампанията.",
        "proof": "Обяснявай механиката, не числата. Не назовавай примерни суми и не обещавай нива на доход.",
        "cta": "Пиши „КРИЕЙТЪР“, ако искаш цените отпред.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Честният отговор на „колко се изкарва“ е: пише го на заданието.",
        "script": "Няма единна тарифа и няма да ти обещая сума. Ето какво има: всеки brief обявява възнаграждение за прието видео. По-сложното задание — повече подготовка, тест на продукт, сценарий — обикновено носи по-висока цена. Ти виждаш числото, преценяваш усилието и решаваш. Никой не ти дължи прехрана, но никой и не крие цената.",
        "duration": 32,
        "visuals": "Три brief карти с различни нива на сложност и различни (замъглени) суми — фокус върху структурата, не числата.",
        "overlay_text": "Цената е на заданието",
        "audio": "Три card SFX при показването",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Виждаш числото, преценяваш усилието, решаваш. Пиши „КРИЕЙТЪР“, ако искаш цените отпред.",
        "cover": "Колко се изкарва?",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C25",
        "audience": "creator",
        "title": "Звукът реже повече видеа от картината",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да насочи вниманието на creators към звука като най-подценявания технически фактор.",
        "pain": "Creator-ът снима добър кадър в шумна стая и видеото е неизползваемо, без да разбира защо.",
        "belief_shift": "Зрителят прощава несъвършена картина, но не и неразбираема реч.",
        "mechanism": "Брандовете в Pactios отказват видеа с лош звук, защото рекламите им трябва да се чуват на телефон в шумна среда.",
        "proof": "Технически съвет. Не изисквай купуване на оборудване.",
        "cta": "Запази това преди следващия запис.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Тестът е прост: затвори очи и слушай.",
        "script": "Пусни последното си видео със затворени очи. Чува ли се всяка дума, или ехото на банята говори с теб? Картината прощава: леко тъмно, леко треперене — ок. Звукът не прощава. Снимай в тиха стая, близо до телефона, без климатик и улица зад гърба. Мека стая — завеси, диван, дрехи — попива ехото. Безплатно е.",
        "duration": 31,
        "visuals": "Кадър в кънтяща празна стая, после same реч в стая със завеси и мек диван. Покажи разстоянието до телефона.",
        "overlay_text": "Чуй преди да пратиш",
        "audio": "Нарочно ехо в първия кадър, чиста реч във втория",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Зрителят прощава картина, не и звук. Запази това преди следващия запис.",
        "cover": "Звукът решава",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C26",
        "audience": "creator",
        "title": "Изпрати видеото. После тишина.",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да назове ghosting болката и да ѝ противопостави срочния преглед.",
        "pain": "Creator-ът предава работа и чака отговор седмици, без да знае дали да разчита на плащане.",
        "belief_shift": "Чакането без отговор не е нормална цена на работата — прегледът може да има краен срок.",
        "mechanism": "Pactios брандовете преглеждат submissions в срок от 72 часа, така че creator-ът не виси в неизвестност.",
        "proof": "Опиши правилото за срок на преглед. Не обещавай положителен отговор, само навременен.",
        "cta": "Пиши „КРИЕЙТЪР“, ако мразиш тишината след „изпрати“.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Най-тежката част не е работата, а тишината след нея.",
        "script": "Предаваш видеото във вторник. Петък: нищо. Следващата седмица: „ще го гледаме“. След месец вече те е срам да попиташ. Тук прегледът има краен срок: брандът дължи решение до 72 часа. Може да е „да“, може да е „не“ с причина — но не е мълчание. Времето ти струва, дори когато отговорът е отказ.",
        "duration": 31,
        "visuals": "Телефон с изпратено съобщение и растящи дни отгоре: 3, 9, 17. После таймер, който спира на 72 часа с решение.",
        "overlay_text": "Решение до 72 часа",
        "audio": "Тихо tick-tock, прекъснато от decision SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Може да е „не“, но не е мълчание. Пиши „КРИЕЙТЪР“, ако мразиш тишината след „изпрати“.",
        "cover": "Край на тишината",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C27",
        "audience": "creator",
        "title": "Три дубъла, един избор",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да даде проста работна рутина срещу перфекционисткото презаснимане.",
        "pain": "Creator-ът снима двайсет дубъла, изтощава се и накрая изпраща първия — или нищо.",
        "belief_shift": "Ограничението на дубли пази енергията и качеството: три опита, най-добрият печели.",
        "mechanism": "Raw UGC форматът в Pactios цени естествеността, която живее в ранните дубли, не в двайсетия.",
        "proof": "Работна рутина. Не твърди, че повече дубли са винаги грешка.",
        "cta": "Запази това за следващото снимане.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Перфекционизмът е крадец на дубли.",
        "script": "Дубъл едно: загряваш. Дубъл две: намираш темпото. Дубъл три: казваш го като човек. Стоп. Двайсетият дубъл не е по-добър — само по-уморен, а умората се чува. Правилото „три и избирам“ пази естествеността, заради която брандът изобщо те търси. Свежият дубъл две бие изтощения дубъл двайсет почти винаги.",
        "duration": 30,
        "visuals": "Три пръста, свивани един по един при всеки дубъл. После ръка избира втория клип от три на екрана.",
        "overlay_text": "3 дубъла максимум",
        "audio": "Три меки clap SFX като клапа",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Естествеността живее в ранните дубли. Запази това за следващото снимане.",
        "cover": "Спри на третия дубъл",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C28",
        "audience": "creator",
        "title": "Какво да направиш след отказ",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да превърне отказа от демотиватор в конкретна следваща стъпка.",
        "pain": "Creator-ът получава първия си отказ, приема го лично и спира да участва.",
        "belief_shift": "Отказът с причина е насока за следващото видео, а не оценка за теб като човек.",
        "mechanism": "Всеки отказ в Pactios идва с причина — четеш я, коригираш едно нещо и участваш в следващия brief.",
        "proof": "Процесен съвет за учене. Не обещавай, че корекцията гарантира приемане следващия път.",
        "cta": "Запази това за деня с първото „не“.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Планът за отказа се прави преди отказа.",
        "script": "Ще ти откажат видео. На всички се случва и не значи, че не ставаш. Разликата е в следващите десет минути: прочети причината — тя е написана, не я гадаеш. Извади едно конкретно нещо: късен продукт, тих звук, забравена забрана. Следващото видео поправя точно него. Отказ, причина, корекция, следващ brief. Това е целият цикъл.",
        "duration": 31,
        "visuals": "Екран с отказ и причина, ръка си записва една дума в тефтер, после отваря следващото задание.",
        "overlay_text": "Причина → корекция → следващ",
        "audio": "Тих write SFX, после page turn",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Отказът е насока, не присъда. Запази това за деня с първото „не“.",
        "cover": "След първото „не“",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C29",
        "audience": "creator",
        "title": "UGC creator не значи инфлуенсър",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да разграничи двете роли и да покаже, че UGC е отделна професионална писта.",
        "pain": "Creator-ът смята, че трябва първо да стане популярен, за да работи с брандове.",
        "belief_shift": "UGC е занаят на изпълнението, инфлуенсър моделът е бизнес с аудитория — пътищата са отделни.",
        "mechanism": "Pactios raw UGC заданията купуват видео умение за каналите на бранда, без изискване за публикуване или брой followers.",
        "proof": "Разграничение на роли. Не омаловажавай инфлуенсър пътя и не обещавай кариерни резултати.",
        "cta": "Пиши „КРИЕЙТЪР“, ако вторият път ти пасва.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Това са две различни професии с една камера.",
        "script": "Инфлуенсърът строи аудитория с години и продава достъпа до нея. UGC creator-ът продава друго: умението да направи убедително видео за чужди канали. Първото иска публичност и постоянство на показ. Второто иска изпълнение — и може да остане почти невидимо. Ако не ти се строи империя от followers, пистата с изпълнението пак е отворена.",
        "duration": 31,
        "visuals": "Две пътеки на екран: сцена с прожектор и тихо бюро с телефон и продукт. Тръгни по втората.",
        "overlay_text": "Занаят, не слава",
        "audio": "Приглушен crowd SFX, после тиха стая",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "UGC е занаят на изпълнението, не конкурс за популярност. Пиши „КРИЕЙТЪР“, ако вторият път ти пасва.",
        "cover": "Не ти трябва слава",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C30",
        "audience": "creator",
        "title": "Ти избираш кампаниите",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да покаже автономията на creator-а при избора на задания.",
        "pain": "Creator-ът очаква да бъде разпределян по задачи и да няма думата какво снима.",
        "belief_shift": "Участието е избор: разглеждаш заданията и влизаш само в тези, които ти пасват.",
        "mechanism": "В Pactios creators разглеждат отворените brief-ове с условията им и сами решават къде да участват.",
        "proof": "Продуктова механика на избора. Не обещавай постоянно изобилие от задания.",
        "cta": "Пиши „КРИЕЙТЪР“, ако искаш ти да избираш.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Тук никой не те разпределя.",
        "script": "Никой не ти назначава крем против бръчки, ако снимаш фитнес съдържание. Отваряш списъка със задания: продукт, условия, възнаграждение, срок. Харесва ти — участваш. Не ти пасва — подминаваш без обяснения. Изборът кое видео носи името ти остава при теб. Платформата носи заданията, ти носиш решението.",
        "duration": 30,
        "visuals": "Скролване през списък brief карти; две се подминават, една се отваря с tap.",
        "overlay_text": "Ти решаваш кое",
        "audio": "Леки scroll SFX, отчетлив tap на избора",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Платформата носи заданията, ти носиш решението. Пиши „КРИЕЙТЪР“, ако искаш ти да избираш.",
        "cover": "Изборът е твой",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C31",
        "audience": "creator",
        "title": "Портфолио с продукти от вкъщи",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да даде конкретен начин за създаване на примерни видеа без клиенти.",
        "pain": "Creator-ът иска да участва, но няма какво да покаже, защото никой още не му е възлагал работа.",
        "belief_shift": "Примерите се създават, не се чакат: всеки продукт в дома ти е тренировъчно задание.",
        "mechanism": "Pactios brief-овете се оценяват по примерни видеа, а те може да са за кафемашината и раницата ти.",
        "proof": "Практически метод. Не обещавай, че портфолиото гарантира приемане в кампании.",
        "cta": "Запази видеото и заснеми първия пример днес.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Портфолиото не чака разрешение.",
        "script": "Нямаш клиенти? Имаш кухня. Кафемашината: проблем — сънлива сутрин, демонстрация — първата глътка. Раницата: колко неща влизат и как. Слушалките: шумът, който изчезва. Снимай ги, все едно брандът те е помолил: hook, демонстрация, честно мнение. Три такива видеа са портфолио. Никой не пита дали са били поръчани.",
        "duration": 31,
        "visuals": "Сложи на масата три домашни продукта и снимай мини hook за всеки в бърз монтаж.",
        "overlay_text": "Домът ти е портфолио",
        "audio": "Три кратки whoosh между продуктите",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Примерите се създават, не се чакат. Запази видеото и заснеми първия пример днес.",
        "cover": "Портфолио от кухнята",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C32",
        "audience": "creator",
        "title": "Платиха ти с продукт, който не искаш",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да назове бартерната умора и да позиционира паричното възнаграждение като норма.",
        "pain": "Creator-ът снима срещу „подарък“ — трети крем, втора бутилка — а сметките се плащат с пари.",
        "belief_shift": "Продуктът е реквизит на заданието, а не заплащане за труда.",
        "mechanism": "В Pactios възнаграждението е парично и обявено в brief-а; продуктът, ако има такъв, е за снимките, не вместо плащане.",
        "proof": "Назови модела, без да съдиш конкретни брандове. Не твърди, че бартерът никога не е приемлив.",
        "cta": "Пиши „КРИЕЙТЪР“, ако кремовете ти стигат.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Наемодателят не приема кремове.",
        "script": "„Ще ти изпратим продукта — той остава за теб!“ Целият хонорар: един крем. Снимаш час, монтираш два, а „заплащането“ стои на рафта при другите четири. Продуктът е реквизит — трябва ти, за да снимаш. Плащането е друго нещо и то е в пари, обявени преди да започнеш. Рафтът ти е пълен. Сметките — не.",
        "duration": 30,
        "visuals": "Рафт с пет еднакви „подаръка“, после brief с парично възнаграждение до продукта с етикет „реквизит“.",
        "overlay_text": "Продукт ≠ заплащане",
        "audio": "Глух thud на поредния продукт върху рафта",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Продуктът е реквизит, плащането е в пари. Пиши „КРИЕЙТЪР“, ако кремовете ти стигат.",
        "cover": "Стига бартери",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C33",
        "audience": "creator",
        "title": "Разчети brief-а за пет минути",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да даде метод за бързо и пълно разбиране на заданието преди снимане.",
        "pain": "Creator-ът прочита заданието по диагонал, снима с ентусиазъм и пропуска изискване, което му коства отказ.",
        "belief_shift": "Пет минути четене с молив спестяват часове презаснемане.",
        "mechanism": "Pactios brief-ът има пет ключови зони — продукт, ъгъл, забрани, формат, срок — и проверката им е кратка рутина.",
        "proof": "Метод за четене. Не обещавай приемане при спазен brief.",
        "cta": "Запази това преди следващото задание.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Снимай чак когато можеш да преразкажеш заданието.",
        "script": "Пет въпроса, пет минути. Какво продавам — продуктът и главната му полза. Какъв ъгъл иска брандът — болка, демонстрация или доверие. Какво не бива да казвам — забраните, дословно. Какъв формат — дължина, ориентация, човек в кадър. До кога — срокът, със запас за преснимане. Можеш ли да отговориш без да поглеждаш? Снимай.",
        "duration": 32,
        "visuals": "Ръка с молив минава по brief и огражда пет зони, номерирайки ги на екрана.",
        "overlay_text": "5 въпроса преди запис",
        "audio": "Пет тихи pencil circle SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Пет минути четене спестяват часове преснимане. Запази това преди следващото задание.",
        "cover": "Прочети като професионалист",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C34",
        "audience": "creator",
        "title": "Първото ти видео няма да е перфектно",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да отблокира стартиращите creators, парализирани от сравнение с опитните.",
        "pain": "Creator-ът гледа гладките видеа на другите и не започва, защото неговото първо ще е неловко.",
        "belief_shift": "Неловкото първо видео е входът към занаята, а не доказателство за липса на талант.",
        "mechanism": "В Pactios се оценява конкретното submission срещу конкретния brief — никой не гледа колко дълга е историята ти.",
        "proof": "Мотивационен, но честен. Не обещавай бърз прогрес или приемане на ранните видеа.",
        "cta": "Пиши „КРИЕЙТЪР“ и заснеми неловкото първо.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Всеки гладък creator има неловко първо видео.",
        "script": "Видеата, на които се възхищаваш, са нечие двестно видео. Първото им е било като твоето бъдещо първо: скован глас, странни паузи, поглед встрани. Разликата между тях и отказалите се е проста — те са го заснели. Занаятът се учи в движение и никъде другаде. Първото видео има една задача: да съществува.",
        "duration": 30,
        "visuals": "Пусни нарочно нескопосан „пръв дубъл“ на себе си, после плавен настоящ кадър. Усмихни се на разликата.",
        "overlay_text": "Първото само съществува",
        "audio": "Лек tape rewind между двата кадъра",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Занаятът се учи в движение и никъде другаде. Пиши „КРИЕЙТЪР“ и заснеми неловкото първо.",
        "cover": "Просто го заснеми",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C35",
        "audience": "creator",
        "title": "Винаги знаеш къде е видеото ти",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да покаже прозрачността на статуса на submission като продуктово предимство.",
        "pain": "Creator-ът изпраща файл в нечия поща и няма представа дали е получен, гледан или забравен.",
        "belief_shift": "Статусът на работата ти е информация, която ти се полага, а не услуга по настроение.",
        "mechanism": "В Pactios всяко submission има видим статус — изпратено, в преглед, прието или отказано с причина.",
        "proof": "Продуктова механика. Не обещавай конкретна скорост на преминаване между статусите.",
        "cta": "Пиши „КРИЕЙТЪР“, ако мразиш да питаш „получихте ли го?“.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Въпросът „получихте ли го“ не би трябвало да съществува.",
        "script": "Изпращаш видео по имейл и започва гадаенето: стигна ли, гледа ли го някой, да пиша ли пак — или е нахално? Тук гадаене няма: отваряш и виждаш. Изпратено. В преглед. Прието — и какво следва. Отказано — и защо. Работата ти има местоположение по всяко време, без да молиш никого за новини.",
        "duration": 30,
        "visuals": "Екран със submission и статус лента, която се движи по стъпките. Без драматизъм, чист интерфейс.",
        "overlay_text": "Статусът е видим",
        "audio": "Меки step SFX по лентата",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Работата ти има местоположение по всяко време. Пиши „КРИЕЙТЪР“, ако мразиш да питаш „получихте ли го?“.",
        "cover": "Къде е видеото ми?",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C36",
        "audience": "creator",
        "title": "Три платформи, три inbox-а",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да назове разпокъсаността на creator работата и да предложи единно място.",
        "pain": "Заданията идват по имейл, Instagram и Viber, файловете висят в три облака и нищо няма единен статус.",
        "belief_shift": "Работният хаос не е част от професията — той е липса на едно работно място.",
        "mechanism": "Pactios събира заданията, изпращането и решенията в един процес, вместо в три инбокса и пет чата.",
        "proof": "Оперативно сравнение. Не твърди, че платформата замества цялата комуникация в живота ти.",
        "cta": "Пиши „КРИЕЙТЪР“, ако работата ти живее в пет чата.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Работата не е тежка — разпръсната е.",
        "script": "Брифът е в пощата, корекцията е гласово в месинджъра, файлът е в трети облак, а „одобрено“ дойде в чат, който вече не намираш. Всяко нещо е на място, което не е неговото. Когато заданието, видеото и решението стоят в един процес, главата ти спира да бъде органайзер и се връща към снимането.",
        "duration": 30,
        "visuals": "Четири приложения, отворени едно върху друго в хаос, после един подреден екран с задание, файл и статус.",
        "overlay_text": "Едно място за работата",
        "audio": "Наслагващи се notification тонове, после тишина",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Главата ти е за снимане, не за органайзер. Пиши „КРИЕЙТЪР“, ако работата ти живее в пет чата.",
        "cover": "Събери работата си",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C37",
        "audience": "creator",
        "title": "Това не е пасивен доход",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Висок",
        "goal": "Да постави честна граница срещу очакването за лесни пари от UGC.",
        "pain": "Creator-ът идва след видео „как изкарвам хиляди, докато спя“ и се удря в реалността на занаята.",
        "belief_shift": "UGC е работа с реални изисквания и реално заплащане — не схема за доход без усилие.",
        "mechanism": "В Pactios се плаща за прието видео: зад всяко приемане стоят четене на brief, снимане, преснимане и срокове.",
        "proof": "Гранична комуникация: не обещавай нива на доход, не описвай „лекота“, не съди хората с други очаквания.",
        "cta": "Пиши „КРИЕЙТЪР“, ако търсиш работа, не магия.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Затова нека сме честни, преди да сме колеги.",
        "script": "Интернет е пълен с „снимай две видеа и живей от това“. Ето реалността: четеш задания, снимаш, понякога преснимаш, спазваш срокове — и ти плащат за приетата работа. Това е занаят с истински пари и истински усилия. Ако търсиш доход, докато спиш — не сме ние. Ако търсиш честна работа с камера — говорим си.",
        "duration": 31,
        "visuals": "Хамак и коктейл, зачертани с пръст. После бюро, телефон на стойка, бележник със срокове.",
        "overlay_text": "Занаят, не схема",
        "audio": "Балон pop върху хамака, после спокоен room tone",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Истински пари срещу истинска работа. Пиши „КРИЕЙТЪР“, ако търсиш работа, не магия.",
        "cover": "Честно за парите",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C38",
        "audience": "creator",
        "title": "Покажи продукта в действие",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да измести creators от описване към демонстриране.",
        "pain": "Creator-ът изрежда характеристики на камера, вместо да покаже какво продуктът прави, и видеото не убеждава.",
        "belief_shift": "Демонстрацията носи доказателството: зрителят вярва на видяното, не на изброеното.",
        "mechanism": "Pactios brief-овете с демонстрационен ъгъл искат продукта в действие — кадърът е аргументът.",
        "proof": "Изпълнителски съвет. Не съветвай да се преувеличава ефектът на продукта.",
        "cta": "Запази това преди следващото демо видео.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Камерата е за показване, не за четене на етикети.",
        "script": "„Тази бутилка държи водата студена 24 часа“ — думи, които всеки може да каже. Покажи го: лед сутринта, звукът на кубчетата вечерта. Не разказвай, че раницата е голяма — извади от нея лаптоп, обяд и яке. Правилото е просто: всяко твърдение, което може да стане кадър, трябва да стане кадър. Останалото е етикет.",
        "duration": 31,
        "visuals": "Разцепен екран: говореща глава с етикет срещу ръце, които вадят нещата от раницата. Вторият печели.",
        "overlay_text": "Кадърът е аргументът",
        "audio": "Истински продуктови звуци: цип, лед, тупване",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Зрителят вярва на видяното, не на изброеното. Запази това преди следващото демо видео.",
        "cover": "Покажи, не разказвай",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C39",
        "audience": "creator",
        "title": "Срам от камерата: говори на един човек",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да даде работещ трик срещу камера страха на започващите.",
        "pain": "Creator-ът замръзва пред обектива, защото си представя публика, която го съди.",
        "belief_shift": "Камерата не е публика, а един човек — и ти вече умееш да говориш на един човек.",
        "mechanism": "Raw UGC форматът в Pactios търси точно интимния тон на разговор с един човек, не сценично представяне.",
        "proof": "Психологически трик за изпълнение. Не обещавай, че страхът изчезва напълно или бързо.",
        "cta": "Запази това за следващия път, когато замръзнеш.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Трикът е да смалиш публиката до един.",
        "script": "Пред обектива мозъкът вижда салон с хора и включва аларма. Излъжи го: избери един истински човек — приятелка, брат ти — и разкажи на него. Не „здравейте на всички“, а „виж какво открих“. Гласът ти сам ще омекне, ръцете ще се отпуснат. Камерата е един слушател, а с един ти говориш всеки ден.",
        "duration": 30,
        "visuals": "Залепи малка снимка на приятел до обектива и говори към нея. Покажи как рамената се отпускат.",
        "overlay_text": "Говори на един, не на всички",
        "audio": "Дишане, което се успокоява в началото",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Камерата е един слушател, не салон с хора. Запази това за следващия път, когато замръзнеш.",
        "cover": "Против камера страха",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C40",
        "audience": "creator",
        "title": "Първата ти седмица в Pactios",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Продукт",
        "funnel": "Конверсия",
        "claim_risk": "Нисък",
        "goal": "Да направи първите стъпки конкретни и да превърне интереса в записване.",
        "pain": "Creator-ът иска да опита, но не знае какво реално ще прави в началото и отлага.",
        "belief_shift": "Началото е кратка позната поредица от стъпки, не скок в неизвестното.",
        "mechanism": "Първата седмица: профил с примерни видеа, преглед на отворените brief-ове, първо участие по избор.",
        "proof": "Опиши процеса, не резултата. Не обещавай приети видеа или доход през първата седмица.",
        "cta": "Пиши „КРИЕЙТЪР“ и започни седмицата.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Ето как изглеждат първите седем дни, без украса.",
        "script": "Ден едно: правиш профил и качваш два-три примера — може и за домашни продукти. Ден два и три: четеш отворените задания и избираш едно, което ти е по силите. До края на седмицата: снимаш по brief-а, минаваш чеклиста и изпращаш. После чакаш решение с краен срок, не в мъгла. Това е цялата първа седмица. Никакви тайни.",
        "duration": 31,
        "visuals": "Календарна лента от седем дни, върху която се отмятат: профил, избор, снимане, изпращане.",
        "overlay_text": "7 дни, 4 стъпки",
        "audio": "Четири check SFX по лентата",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Началото е поредица от стъпки, не скок. Пиши „КРИЕЙТЪР“ и започни седмицата.",
        "cover": "Първите 7 дни",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C41",
        "audience": "creator",
        "title": "Едно снимане, три варианта",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да научи creators да извличат повече стойност от една снимачна сесия.",
        "pain": "Creator-ът снима по един клип на сесия и харчи ново време за всяка идея.",
        "belief_shift": "Докато декорът е подреден и продуктът е в ръката, вариантите са почти безплатни.",
        "mechanism": "Когато brief-ът позволява няколко submissions, вариантите от една сесия увеличават шансовете при same усилие.",
        "proof": "Работна ефективност. Уточни, че броят submissions зависи от условията на конкретния brief.",
        "cta": "Запази това преди следващата сесия.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Декорът вече е готов — използвай го докрай.",
        "script": "Подредил си светлината, продуктът е в ръката, гласът е загрят. Не спирай на един клип. Same продукт, три начала: веднъж тръгни от проблема, веднъж от резултата, веднъж от изненадата. Десет минути повече, три различни видеа. Ако заданието приема няколко submissions, изпращаш вариантите; ако не — имаш готови примери за портфолиото.",
        "duration": 31,
        "visuals": "Един декор, три бързи начала едно след друго с щракване на пръсти между тях.",
        "overlay_text": "1 сесия = 3 варианта",
        "audio": "Три snap SFX между вариантите",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Вариантите са почти безплатни, докато декорът стои. Запази това преди следващата сесия.",
        "cover": "Изцеди сесията",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C42",
        "audience": "creator",
        "title": "Къде отива видеото ти",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да обясни прозрачно как брандът използва приетото съдържание.",
        "pain": "Creator-ът предава видео и после се чуди къде ще се появи лицето му и за какво е дал съгласие.",
        "belief_shift": "Употребата на видеото е записана предварително, а не решение на бранда постфактум.",
        "mechanism": "Pactios brief-ът описва как приетото видео ще се използва и creator-ът вижда условията преди участие.",
        "proof": "Обясни принципа на предварителните условия. Не давай правни съвети и не изброявай конкретни клаузи.",
        "cta": "Пиши „КРИЕЙТЪР“, ако искаш да знаеш отпред.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Лицето ти е твое — и договорките за него стоят отпред.",
        "script": "Въпросът е напълно легитимен: къде ще се върти видео с моето лице? Отговорът тук не е „ще видим“ — той е в заданието, преди да кажеш „да“. За какви канали е видеото, за реклами ли — условията са част от brief-а, който четеш. Участваш само ако те устройват. Изненадата не е част от сделката.",
        "duration": 30,
        "visuals": "Brief със секция за употреба, маркирана с пръст, после уверено натискане на „участвам“.",
        "overlay_text": "Условията са отпред",
        "audio": "Highlight SFX, после confirm tap",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Изненадата не е част от сделката. Пиши „КРИЕЙТЪР“, ако искаш да знаеш отпред.",
        "cover": "Къде отива клипът ми",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C43",
        "audience": "creator",
        "title": "„Ще те имаме предвид“ не е отговор",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да назове мъглявите откази и да ги противопостави на ясните решения.",
        "pain": "Creator-ът получава любезни безсмислици вместо решения и не може да планира нито времето, нито парите си.",
        "belief_shift": "Професионалният процес дължи ясно „да“ или „не“ — мъглата е скрит разход за creator-а.",
        "mechanism": "В Pactios submission-ът завършва със статус: приет или отказан с причина, в срок.",
        "proof": "Опиши стойността на ясния отговор. Не обещавай повече приемания — само повече яснота.",
        "cta": "Пиши „КРИЕЙТЪР“, ако „ще видим“ ти струва пари.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Любезната мъгла е най-скъпият отговор.",
        "script": "„Ще те имаме предвид.“ „Може би за следващата кампания.“ „Ще се чуем.“ Звучи учтиво, а значи: чакай безкрайно и не планирай нищо. Мъглата ти струва пари, защото държи времето ти резервирано за нищо. Ясното „не, защото“ боли за минута и освобождава седмицата. Тук отговорът е статус със срок, не поезия.",
        "duration": 30,
        "visuals": "Три чат балона с мъгляви фрази се разтварят в дим. После чист статус: отказано + причина.",
        "overlay_text": "Яснота > любезност",
        "audio": "Мек dissolve SFX, после отчетлив статус click",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Ясното „не“ освобождава седмицата ти. Пиши „КРИЕЙТЪР“, ако „ще видим“ ти струва пари.",
        "cover": "Без „ще видим“",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C44",
        "audience": "creator",
        "title": "Дръж продукта в кадър",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да коригира най-честата композиционна грешка в продуктови видеа.",
        "pain": "Creator-ът говори увлекателно, но продуктът лежи извън кадър и брандът няма какво да приеме.",
        "belief_shift": "В продуктово видео продуктът е главният герой — ти си разказвачът, не звездата.",
        "mechanism": "Pactios брандовете преглеждат видеата за видимост на продукта — той трябва да се вижда, държи и използва.",
        "proof": "Композиционен съвет. Не свеждай видеото до реклама без човешка история.",
        "cta": "Запази това преди следващото продуктово видео.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Главният герой не бива да чака зад кадър.",
        "script": "Прегледай дубъла и си задай един въпрос: колко секунди продуктът реално се вижда? Често отговорът е „три, в края“. Дръж го в ръка, докато говориш за него. Покажи етикета спокойно, използвай го в действие. Ти водиш историята, но героят е продуктът. Видео, в което героят липсва, не се приема — независимо колко добре говориш.",
        "duration": 31,
        "visuals": "Два кадъра: разказ с празни ръце срещу same разказ с продукта в ръка, който се използва.",
        "overlay_text": "Продуктът е героят",
        "audio": "Тих spotlight SFX при появата на продукта",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Ти си разказвачът, продуктът е звездата. Запази това преди следващото продуктово видео.",
        "cover": "Къде е продуктът?",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C45",
        "audience": "creator",
        "title": "Кога да откажеш brief",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Среден",
        "goal": "Да научи creators на професионална селекция вместо участие във всичко.",
        "pain": "Creator-ът се хваща за всяко задание, включително неподходящи, и събира откази и изгаряне.",
        "belief_shift": "Отказът от грешното задание е професионално умение, което пази качеството и репутацията ти.",
        "mechanism": "В Pactios участието е по избор — четеш brief-а и преценяваш продукт, срок и съвест, преди да инвестираш време.",
        "proof": "Съвет за селекция. Не съветвай масово отказване и не съди брандовете с изисквания.",
        "cta": "Запази това преди следващото „да“.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Не всяко задание заслужава твоето „да“.",
        "script": "Три честни въпроса преди участие. Мога ли да покажа този продукт убедително — ползвал ли съм такова нещо изобщо? Стига ли ми времето за спокойно снимане, или ще предавам в полунощ на срока? И бих ли препоръчал продукта на човек, когото харесвам? Две колебания значат „пропусни“. Порфолиото ти помни какво си снимал — и какво си отказал.",
        "duration": 32,
        "visuals": "Три врати с въпроси; ръка спира пред третата и спокойно се обръща назад.",
        "overlay_text": "Две колебания = пропусни",
        "audio": "Три меки knock SFX, после стъпки назад",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Отказът от грешното задание пази репутацията. Запази това преди следващото „да“.",
        "cover": "Умей да пропускаш",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C46",
        "audience": "creator",
        "title": "Текстът на екрана: кога помага",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да научи creators да използват overlay текст функционално, а не декоративно.",
        "pain": "Creator-ът или няма никакъв текст, или облепя екрана с думи, които се бият с речта.",
        "belief_shift": "Текстът е за беззвучния зрител и ключовите числа, а не украса върху всяка секунда.",
        "mechanism": "Голяма част от feed гледането е без звук — Pactios брандовете ценят видеа, които работят и на mute.",
        "proof": "Форматен съвет. Не цитирай конкретни проценти беззвучно гледане.",
        "cta": "Запази това преди следващия монтаж.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Половината ти зрители са на mute — пиши за тях.",
        "script": "Много хора гледат без звук: в автобуса, в офиса, до заспиващо дете. За тях екранният текст е субтитрите на идеята: hook-ът с думи, ключовото число, името на продукта. Правилата са три: кратко, едро, едно нещо наведнъж. Текст, който повтаря всяка дума, задушава кадъра. Текст, който подчертава важното, продава и на mute.",
        "duration": 31,
        "visuals": "Едно видео на mute два пъти: без текст (неразбираемо) и с три ключови надписа (ясно).",
        "overlay_text": "Работи ли на mute?",
        "audio": "Нарочно заглушен звук, после чист tone при текста",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Видеото трябва да продава и на mute. Запази това преди следващия монтаж.",
        "cover": "Текстът на екрана",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C47",
        "audience": "creator",
        "title": "Хиляди гледания, нула лева",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Болка",
        "funnel": "Осведоменост",
        "claim_risk": "Нисък",
        "goal": "Да раздели вниманието от дохода и да покаже платения път на изпълнението.",
        "pain": "Creator-ът има видеа с хиляди гледания, но нито един лев от тях, и не разбира къде е грешката.",
        "belief_shift": "Гледанията са валутата на платформите; изпълнението за брандове е валутата, която се осребрява.",
        "mechanism": "В Pactios доходът идва от приети видеа по brief, а не от броя гледания на профила ти.",
        "proof": "Разграничи моделите на монетизация честно. Не твърди, че гледанията никога не носят доход.",
        "cta": "Пиши „КРИЕЙТЪР“, ако гледанията не се превръщат в наем.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Гледанията са аплодисменти — а аплодисментите не са заплата.",
        "script": "Клипът ти удари десетки хиляди гледания. Наемът ти не забеляза. Вниманието е истинско, но то се осребрява трудно и бавно. Другият път е директен: бранд възлага видео, ти го изпълняваш добре, приемат го, плащат ти. Без чакане на алгоритъма и без милион последователи. Умението ти е стоката — не популярността на профила.",
        "duration": 31,
        "visuals": "Брояч на гледания, който расте бясно до банково извлечение с нула. После просто: прието видео → сума.",
        "overlay_text": "Гледания ≠ доход",
        "audio": "Counter SFX, спрян от сух cash register",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Умението е стоката, не популярността. Пиши „КРИЕЙТЪР“, ако гледанията не се превръщат в наем.",
        "cover": "Гледания не плащат наем",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C48",
        "audience": "creator",
        "title": "Снимай за неща, зад които заставаш",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Доверие",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да въведе честността като дългосрочна creator стратегия.",
        "pain": "Creator-ът се чуди дали е редно да хвали продукт, който не би ползвал, и как това се отразява на него.",
        "belief_shift": "Искреността се вижда в кадър: убедителен си точно за нещата, зад които наистина заставаш.",
        "mechanism": "В Pactios избираш заданията си сам — селекцията по съвест е вградена възможност, не героизъм.",
        "proof": "Етичен съвет без морализаторство. Не съди creators с други избори и не обещавай успех от честност.",
        "cta": "Запази това за следващия избор на brief.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Камерата хваща и това, което не казваш.",
        "script": "Може ли да изхвалиш продукт, който не понасяш? Може. Личи ли си? Почти винаги: гласът е с половин тон по-фалшив, ръцете не знаят какво държат. Работи по-простото правило: избирай задания за неща, които би препоръчал на приятел. Убедителността ти е ресурс — харчи я за истини. И спиш по-добре, и видеата са по-добри.",
        "duration": 31,
        "visuals": "Два близки кадъра на same човек: единият с недоверчива микро гримаса, другият с истинска лекота.",
        "overlay_text": "Искреността се снима",
        "audio": "Без ефекти — само двата тона на гласа",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Убедителността е ресурс — харчи я за истини. Запази това за следващия избор на brief.",
        "cover": "Снимай честно",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C49",
        "audience": "creator",
        "title": "30 секунди стигат",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Образование",
        "funnel": "Обмисляне",
        "claim_risk": "Нисък",
        "goal": "Да пребори навика за дълги видеа и да наложи дисциплина на кратката форма.",
        "pain": "Creator-ът разтяга видеото до две минути „за да е пълно“ и губи зрителя и бранда по средата.",
        "belief_shift": "Краткото видео не е орязано дълго — то е дисциплина: една идея, казана без мазнина.",
        "mechanism": "Pactios raw UGC brief-овете задават кратък формат, защото рекламните позиции и вниманието го изискват.",
        "proof": "Форматен принцип. Не твърди, че дългият формат е мъртъв навсякъде.",
        "cta": "Запази това преди следващия монтаж.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Ако не се побира в 30 секунди, значи са две идеи.",
        "script": "Две минути видео за бутилка вода значи, че някъде вътре се крие половин минута истина и деветдесет секунди пълнеж. Форматът тук е кратък нарочно: hook, демонстрация, честно изречение, край. Едно видео носи една идея. Останалите идеи не се изхвърлят — стават следващите видеа. Краткостта не е ограничение, а монтажна честност.",
        "duration": 30,
        "visuals": "Дълга лента на таймлайн, от която се изрязва средата, докато остане стегнат клип. Таймер: 0:30.",
        "overlay_text": "Една идея, 30 секунди",
        "audio": "Scissors SFX при изрязването",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Краткостта е монтажна честност. Запази това преди следващия монтаж.",
        "cover": "Режи смело",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      },
      {
        "id": "C50",
        "audience": "creator",
        "title": "Какво получаваш в ранния достъп — creator версия",
        "batch": "CREATOR-02",
        "status": "Идея",
        "pillar": "Конверсия",
        "funnel": "Конверсия",
        "claim_risk": "Нисък",
        "goal": "Да опише конкретно ползите от ранното записване за creators и да затвори решението.",
        "pain": "Creator-ът се колебае да остави контакт, защото „ранен достъп“ обикновено значи имейл списък и нищо повече.",
        "belief_shift": "Записването носи конкретни неща: ред при старта, насоки за първите примери и директен канал към екипа.",
        "mechanism": "Ранните creators влизат по реда на записване, получават насоки как да подготвят примерни видеа и говорят директно с екипа на Pactios.",
        "proof": "Изброявай само реално планираното. Без обещания за брой задания, доходи или дата на старта.",
        "cta": "Пиши „КРИЕЙТЪР“ и си в списъка.",
        "hook_id": null,
        "hook_file": "",
        "hook_target": 3,
        "bridge": "Ето какво реално стои зад „ранен достъп“.",
        "script": "Пишеш „КРИЕЙТЪР“ и това е цялата процедура. Какво следва: при старта достъпът върви по списъка — ранните влизат първи. Дотогава получаваш насоки как да подготвиш примерните си видеа, за да не започваш от нула. И имаш директен канал към екипа за въпроси. Това е. Без вълшебства — само преднина по ред и подготовка.",
        "duration": 31,
        "visuals": "Три реда, отмятани на екран: ред при старта, насоки за примери, директен канал. Чист кадър.",
        "overlay_text": "Ред · Насоки · Канал",
        "audio": "Три чисти check SFX",
        "raw_file": "",
        "export_file": "",
        "platform": "",
        "publish_date": "",
        "caption": "Преднина по ред и подготовка — това е сделката. Пиши „КРИЕЙТЪР“ и си в списъка.",
        "cover": "Ранен достъп, конкретно",
        "post_url": "",
        "learning": "",
        "created_at": "2026-08-06T00:00:00.000Z",
        "updated_at": "2026-08-06T00:00:00.000Z"
      }
    ],
    "video_qa": [
      {
        "video_id": "B01",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B02",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B03",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B04",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B05",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B06",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B07",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B08",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B09",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B10",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C01",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C02",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C03",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C04",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C05",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C06",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C07",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C08",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C09",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C10",
        "transition_ok": 0,
        "captions_ok": 0,
        "audio_ok": 0,
        "format_ok": 0,
        "claim_ok": 0,
        "silent_ok": 0,
        "updated_at": "2026-07-31T07:12:02.951+00:00"
      }
    ],
    "video_metric_snapshots": [
      {
        "video_id": "B01",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B01",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B02",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B02",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B03",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B03",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B04",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B04",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B05",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B05",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B06",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B06",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B07",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B07",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B08",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B08",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B09",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B09",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B10",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "B10",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C01",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C01",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C02",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C02",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C03",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C03",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C04",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C04",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C05",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C05",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C06",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C06",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C07",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C07",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C08",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C08",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C09",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C09",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C10",
        "window_key": "24h",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "video_id": "C10",
        "window_key": "7d",
        "views": 0,
        "avg_watch": 0.0,
        "completion": 0.0,
        "shares_saves": 0,
        "profile_actions": 0,
        "leads": 0,
        "captured_at": "2026-07-31T07:12:02.951+00:00"
      }
    ],
    "video_events": [
      {
        "event_id": 1,
        "video_id": "B01",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 2,
        "video_id": "B02",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 3,
        "video_id": "B03",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 4,
        "video_id": "B04",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 5,
        "video_id": "B05",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 6,
        "video_id": "B06",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 7,
        "video_id": "B07",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 8,
        "video_id": "B08",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 9,
        "video_id": "B09",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 10,
        "video_id": "B10",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 11,
        "video_id": "C01",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 12,
        "video_id": "C02",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 13,
        "video_id": "C03",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 14,
        "video_id": "C04",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 15,
        "video_id": "C05",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 16,
        "video_id": "C06",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 17,
        "video_id": "C07",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 18,
        "video_id": "C08",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 19,
        "video_id": "C09",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 20,
        "video_id": "C10",
        "event_type": "video_created",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"status\": \"Идея\", \"previous_status\": null}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 21,
        "video_id": null,
        "event_type": "dataset_synced",
        "payload_json": "{\"source\": \"browser_bootstrap\", \"row_count\": 20, \"inserted\": 20, \"updated\": 0, \"deleted\": 0}",
        "created_at": "2026-07-31T07:04:45.405+00:00"
      },
      {
        "event_id": 22,
        "video_id": "B01",
        "event_type": "stage_changed",
        "payload_json": "{\"source\": \"video_saved\", \"status\": \"Hook избран\", \"previous_status\": \"Идея\"}",
        "created_at": "2026-07-31T07:08:28.463+00:00"
      },
      {
        "event_id": 23,
        "video_id": "B01",
        "event_type": "dataset_synced",
        "payload_json": "{\"source\": \"video_saved\", \"row_count\": 20, \"inserted\": 0, \"updated\": 1, \"deleted\": 0}",
        "created_at": "2026-07-31T07:08:28.463+00:00"
      },
      {
        "event_id": 24,
        "video_id": "B01",
        "event_type": "stage_changed",
        "payload_json": "{\"source\": \"seed_reset\", \"status\": \"Идея\", \"previous_status\": \"Hook избран\"}",
        "created_at": "2026-07-31T07:12:02.951+00:00"
      },
      {
        "event_id": 25,
        "video_id": null,
        "event_type": "dataset_synced",
        "payload_json": "{\"source\": \"seed_reset\", \"row_count\": 20, \"inserted\": 0, \"updated\": 1, \"deleted\": 0}",
        "created_at": "2026-07-31T07:12:02.951+00:00"
      }
    ],
    "settings": [
      {
        "key": "schema_version",
        "value": "2",
        "updated_at": "2026-08-03T08:43:28.075+00:00"
      }
    ],
    "legal_questionnaire_responses": [],
    "legal_questionnaire_events": []
  }
}
